var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-medical-prescription",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-medical-prescription:not(.animated) .animable {opacity: 0;}svg#freepik_stories-medical-prescription.animated #freepik--Floor--inject-114 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}svg#freepik_stories-medical-prescription.animated #freepik--Window--inject-114 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}svg#freepik_stories-medical-prescription.animated #freepik--Plant--inject-114 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-medical-prescription.animated #freepik--Diplomas--inject-114 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}svg#freepik_stories-medical-prescription.animated #freepik--Shadows--inject-114 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-medical-prescription.animated #freepik--Symbol--inject-114 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}svg#freepik_stories-medical-prescription.animated #freepik--Clipboard--inject-114 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}svg#freepik_stories-medical-prescription.animated #freepik--Medicines--inject-114 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}svg#freepik_stories-medical-prescription.animated #freepik--Character--inject-114 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}svg#freepik_stories-medical-prescription.animated #freepik--speech-bubble--inject-114 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}            @keyframes lightSpeedLeft {              from {                transform: translate3d(-50%, 0, 0) skewX(20deg);                opacity: 0;              }              60% {                transform: skewX(-10deg);                opacity: 1;              }              80% {                transform: skewX(2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes zoomIn {                0% {                    opacity: 0;                    transform: scale(0.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes slideUp {                0% {                    opacity: 0;                    transform: translateY(30px);                }                100% {                    opacity: 1;                    transform: inherit;                }            }                    @keyframes fadeIn {                0% {                    opacity: 0;                }                100% {                    opacity: 1;                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-114",
    className: "animable",
    style: {
      transformOrigin: "247px 366.15px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-114",
    cx: 247,
    cy: 366.15,
    rx: 231.26,
    ry: 130.46,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "247px 366.15px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-114",
    className: "animable",
    style: {
      transformOrigin: "427.33px 133.365px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-114",
    className: "animable",
    style: {
      transformOrigin: "427.33px 133.365px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-114",
    className: "animable",
    style: {
      transformOrigin: "427.33px 133.365px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Frame--inject-114",
    className: "animable",
    style: {
      transformOrigin: "427.33px 133.365px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "470.52 229.29 468.05 230.76 384.11 182.3 386.58 180.83 470.52 229.29",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "427.315px 205.795px"
    },
    id: "elnvx6s65b0h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.58 180.83 468.05 227.86 468.05 85.85 386.58 38.84 386.58 180.83",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "427.315px 133.35px"
    },
    id: "elkvg65vm827",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.45,185l93.26,53.84V83.16L379.45,29.32Zm4.66-147.6,83.94,48.46V230.76L384.11,182.3Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "426.08px 134.08px"
    },
    id: "elrjwmannbdm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.11 182.3 386.58 180.83 386.58 38.84 384.11 37.39 384.11 182.3",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "385.345px 109.845px"
    },
    id: "elc3qzcjudbas",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "468.05 194.19 468.05 197.09 384.11 148.63 386.58 147.16 468.05 194.19",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "426.08px 172.125px"
    },
    id: "el2tpern31s8m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "468.05 111.26 468.05 114.16 384.11 65.7 386.58 64.22 468.05 111.26",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "426.08px 89.19px"
    },
    id: "elr36jjwlccxp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.45 29.32 381.96 27.89 475.21 81.73 472.71 83.16 379.45 29.32",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "427.33px 55.525px"
    },
    id: "ell4iu4p0zjr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "475.21 81.73 472.71 83.16 472.71 238.83 475.21 237.39 475.21 81.73",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "473.96px 160.28px"
    },
    id: "elsckobrefwpg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.15 65.12 429.64 63.67 429.64 208.59 432.15 207.16 432.15 65.12",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "430.895px 136.13px"
    },
    id: "el7r8vv4lq5ee",
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "424.99 61 429.64 63.67 429.64 208.59 424.99 205.9 424.99 61",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "427.315px 134.795px"
    },
    id: "ellboru0evech",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.45 63.01 379.45 68.38 472.71 122.22 472.71 116.85 379.45 63.01",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "426.08px 92.615px"
    },
    id: "elz8200uz7oir",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.45 145.93 379.45 151.3 472.71 205.14 472.71 199.77 379.45 145.93",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "426.08px 175.535px"
    },
    id: "el524124rp1r4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.64 91.98 432.15 90.53 468.05 111.26 468.05 114.16 429.64 91.98",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "448.845px 102.345px"
    },
    id: "eljpf9nhcdq1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.64 174.89 432.15 173.44 468.05 194.16 468.05 197.06 429.64 174.89",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "448.845px 185.25px"
    },
    id: "el8ocdvjzs3pt",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-114",
    className: "animable",
    style: {
      transformOrigin: "43.5877px 355.889px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-114",
    className: "animable",
    style: {
      transformOrigin: "43.5877px 355.889px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.39,406a.55.55,0,0,1-.23-.39c-2-21.54-20.31-37.13-28.14-43.79-1.26-1.07-2.26-1.92-2.9-2.55-2.87-2.8-4.12-6.48-3.33-9.84A9.09,9.09,0,0,1,25.16,343c8.17-2.67,21,7.47,29.19,23.06,11.49,21.86,6.1,38,6,38.14a.53.53,0,0,1-.37.34l-6.19,1.59a.41.41,0,0,1-.22,0A.43.43,0,0,1,53.39,406Zm0-39.49c-8-15.15-20.22-25-27.92-22.55a8,8,0,0,0-5.66,5.71,9.5,9.5,0,0,0,3,8.84c.62.6,1.61,1.44,2.85,2.5,7.86,6.68,26.14,22.23,28.45,43.88l5.3-1.36C60.1,401.39,63.86,386.42,53.41,366.53Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "40.1284px 374.359px"
    },
    id: "el4cnbwwhz3nc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.13,405.21h.07a.54.54,0,0,0,.55-.53c.46-25.16-17-49.41-28.68-54.4a.53.53,0,0,0-.42,1c11.59,4.94,28.46,29.54,28,53.4A.53.53,0,0,0,57.13,405.21Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "43.0396px 377.724px"
    },
    id: "elygx723w6n5m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.81,404.52a.6.6,0,0,0,.23,0l4.2-1.27a.59.59,0,0,0,.36-.35c.07-.24,7.48-24.29,2-56.67-2.78-16.5-12.4-32.59-22.87-38.27-5-2.72-10-3.06-14.7-1-2.68,1.16-4.35,2.88-5,5.09-1.74,6.13,4.62,15.25,11.36,24.91,4.71,6.76,9.58,13.74,11.81,19.91a.53.53,0,0,0,1-.36c-2.27-6.3-7.18-13.35-11.93-20.16-6.59-9.45-12.81-18.36-11.22-24,.55-1.92,2-3.36,4.37-4.41,4.41-1.92,9-1.59,13.77,1,10.21,5.53,19.6,21.3,22.33,37.5,5.1,30.3-1.12,53.18-1.91,55.9l-3.93,1.18a.54.54,0,0,0-.35.67A.53.53,0,0,0,59.81,404.52Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "46.1786px 355.082px"
    },
    id: "eleeqo62vd0he",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.85,389.21h0a.54.54,0,0,0,.57-.49c3.17-38.93-18.55-70.1-25-75.45a.54.54,0,0,0-.76.07.53.53,0,0,0,.07.75c6.33,5.27,27.73,36,24.6,74.54A.52.52,0,0,0,60.85,389.21Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "48.6352px 351.178px"
    },
    id: "elcaeatftao4",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Diplomas--inject-114",
    className: "animable",
    style: {
      transformOrigin: "46.56px 122.22px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Diploma--inject-114",
    className: "animable",
    style: {
      transformOrigin: "46.56px 63.61px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-114",
    className: "animable",
    style: {
      transformOrigin: "46.56px 63.61px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "23.59 95.25 25.36 96.27 69.53 70.76 67.76 69.74 23.59 95.25",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "46.56px 83.005px"
    },
    id: "eldwb1z85x2w5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.76 69.74 25.36 94.22 25.36 57.47 67.76 32.99 67.76 69.74",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "46.56px 63.605px"
    },
    id: "ell7weqq16gbb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3,28.91,23.59,56.45V99.32L71.3,71.78ZM69.53,70.76,25.36,96.26V57.47L69.53,32Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "47.445px 64.115px"
    },
    id: "elmi9n99od8bm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.53 70.76 67.76 69.74 67.76 32.99 69.53 31.97 69.53 70.76",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "68.645px 51.365px"
    },
    id: "el0u6od2b0kqj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.3 28.91 69.53 27.89 21.82 55.43 23.59 56.45 71.3 28.91",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "46.56px 42.17px"
    },
    id: "ell7uxsm7c2kd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.82 55.43 23.59 56.45 23.59 99.33 21.82 98.31 21.82 55.43",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "22.705px 77.38px"
    },
    id: "elq6ak7j32lll",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.45,63.56c1.64-1,3-.18,3,1.72a6.6,6.6,0,0,1-3,5.17c-1.65,1-3,.18-3-1.72A6.6,6.6,0,0,1,59.45,63.56Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "59.45px 67.005px"
    },
    id: "elf1xkewoj0qr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.35,55.8l22.45-13c.63-.36,1.13-.07,1.13.65v.07a2.49,2.49,0,0,1-1.13,2l-22.45,13c-.63.37-1.13.07-1.13-.65v-.07A2.47,2.47,0,0,1,35.35,55.8Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "46.575px 50.6622px"
    },
    id: "elfmhj5grepgl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.79,66,61.35,49c.62-.36,1.13-.2,1.13.37A2.27,2.27,0,0,1,61.35,51L31.77,68.07c-.63.36-1.13.19-1.12-.38A2.32,2.32,0,0,1,31.79,66Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "46.5649px 58.5335px"
    },
    id: "ely3olby6q4o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.79,70.09,61.35,53c.62-.36,1.13-.2,1.13.36a2.27,2.27,0,0,1-1.13,1.68L31.77,72.14c-.63.37-1.13.2-1.12-.37A2.32,2.32,0,0,1,31.79,70.09Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "46.5649px 62.572px"
    },
    id: "elkpkzngej4r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.79,74.17,61.35,57.1c.62-.36,1.13-.19,1.13.37a2.27,2.27,0,0,1-1.13,1.67L31.77,76.22c-.63.36-1.13.19-1.12-.37A2.32,2.32,0,0,1,31.79,74.17Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "46.5649px 66.66px"
    },
    id: "el2zdeu9sh0lf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.14,72.29a1.57,1.57,0,0,1-.74.19c-.63,0-.57-.64-.55-1.08,0-.21-.27-.51-.42-.25-.38.69-.87,1.33-1.28,2-.25.41-.73,1.34-1.34,1.21-.25-.06-.33-.33-.33-.67a3.33,3.33,0,0,0,.39-1.84c0-.19-.35-.43-.45-.17a6,6,0,0,0-.38,1.7,11.32,11.32,0,0,1-.95,1.42c-.21.27-.39.58-.62.83,0,.06-.16.22-.24.24s-.19-.09-.22-.23a1.63,1.63,0,0,1,.1-.61h0l0-.05h0c0-.2-.26-.5-.37-.25A8.87,8.87,0,0,1,45,77.63l-.11.09c0-.11,0-.23,0-.35a2.69,2.69,0,0,0-.14-.8c0-.13-.27-.33-.39-.16a14,14,0,0,1-2,2.72,4.13,4.13,0,0,1-.41.29c-.14-.08.07-.8.1-.9.08-.33.19-.64.29-1a4,4,0,0,0,.24-.79c0-.24-.38-.61-.46-.29,0,.14-.15.46-.27.86a20.33,20.33,0,0,1-1.66,2.81,6.39,6.39,0,0,1-2.31,2.22c-.26.14-.75.35-1,.14s-.26-.57-.27-.83a7.09,7.09,0,0,1,.28-2,12.29,12.29,0,0,0,2.56-1.81,8.78,8.78,0,0,0,1.94-2.14c.26-.48.42-1.26-.22-1.53a1.77,1.77,0,0,0-1.38.33,6,6,0,0,0-1.41,1.1,8.13,8.13,0,0,0-1.76,3.22c-.06.18-.13.43-.2.7a5.5,5.5,0,0,1-3.26.55c-.06,0-.08.13,0,.14a5.33,5.33,0,0,0,3.18-.3c-.28,1.23-.44,2.86.71,3.18s2.54-1.12,3.16-2a13.48,13.48,0,0,0,1.23-2,.83.83,0,0,1,.11-.15c0,.57.11,1,.67.9s1.09-.91,1.4-1.34.57-.85.84-1.27c.05.51.15,1.1.64,1s.9-1,1.13-1.3.39-.61.56-.93a.62.62,0,0,0,.11.17c.41.44.9,0,1.16-.38s.8-1,1.15-1.57a1,1,0,0,0,.49.55c.63.3,1.23-.22,1.59-.69a13.87,13.87,0,0,0,1.19-1.91.88.88,0,0,0,.44.6,1.46,1.46,0,0,0,1.48-.09C54.54,72.61,54.35,72.18,54.14,72.29ZM40.31,74.76c.29-.15.9-.4.94.09a1.7,1.7,0,0,1-.4.87,11.45,11.45,0,0,1-1.72,1.83A14.49,14.49,0,0,1,37,79.18,6.89,6.89,0,0,1,40.31,74.76Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "43.7776px 77.0873px"
    },
    id: "el1mq4yab3sqg",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--diploma--inject-114",
    className: "animable",
    style: {
      transformOrigin: "46.56px 122.22px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-114",
    className: "animable",
    style: {
      transformOrigin: "46.56px 122.22px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "23.59 153.86 25.36 154.88 69.53 129.38 67.76 128.35 23.59 153.86",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "46.56px 141.615px"
    },
    id: "eldy25z1ufjj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.76 128.35 25.36 152.84 25.36 116.08 67.76 91.6 67.76 128.35",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "46.56px 122.22px"
    },
    id: "elnvrzb87l8wg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3,87.52,23.59,115.06v42.88L71.3,130.39Zm-1.77,41.85L25.36,154.88v-38.8l44.17-25.5Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "47.445px 122.73px"
    },
    id: "el3v3a2rx35f7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.53 129.38 67.76 128.35 67.76 91.6 69.53 90.58 69.53 129.38",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "68.645px 109.98px"
    },
    id: "elainh2wdxcou",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.3 87.52 69.53 86.5 21.82 114.04 23.59 115.06 71.3 87.52",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "46.56px 100.78px"
    },
    id: "elo6d2fh50eel",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.82 114.04 23.59 115.06 23.59 157.94 21.82 156.92 21.82 114.04",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "22.705px 135.99px"
    },
    id: "el8jbrsv10rp",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.45,122.18c1.64-1,3-.19,3,1.72a6.6,6.6,0,0,1-3,5.16c-1.65.95-3,.18-3-1.72A6.58,6.58,0,0,1,59.45,122.18Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "59.45px 125.608px"
    },
    id: "eltzuaopzxkgm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.35,114.41l22.45-13c.63-.36,1.13-.06,1.13.66v.06a2.49,2.49,0,0,1-1.13,2l-22.45,13c-.63.36-1.13.07-1.13-.66v-.07A2.49,2.49,0,0,1,35.35,114.41Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "46.575px 109.271px"
    },
    id: "elunq4sdewyog",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.79,124.63l29.56-17.07c.62-.36,1.13-.19,1.13.37a2.27,2.27,0,0,1-1.13,1.67L31.77,126.68c-.63.36-1.13.19-1.12-.37A2.32,2.32,0,0,1,31.79,124.63Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "46.5649px 117.12px"
    },
    id: "el9jklgvrp3k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.79,128.7l29.56-17.06c.62-.36,1.13-.2,1.13.37a2.27,2.27,0,0,1-1.13,1.67L31.77,130.76c-.63.36-1.13.19-1.12-.38A2.33,2.33,0,0,1,31.79,128.7Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "46.5649px 121.199px"
    },
    id: "elekskaybp39n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.79,132.78l29.56-17.06c.62-.36,1.13-.2,1.13.36a2.27,2.27,0,0,1-1.13,1.68L31.77,134.83c-.63.36-1.13.2-1.12-.37A2.32,2.32,0,0,1,31.79,132.78Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "46.5649px 125.275px"
    },
    id: "elgm6qunz5hm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.14,130.9a1.7,1.7,0,0,1-.74.2c-.63,0-.57-.65-.55-1.09,0-.2-.27-.51-.42-.25-.38.7-.87,1.34-1.28,2-.25.41-.73,1.34-1.34,1.21-.25-.06-.33-.33-.33-.67a3.33,3.33,0,0,0,.39-1.84c0-.19-.35-.43-.45-.17A6,6,0,0,0,49,132a11.32,11.32,0,0,1-.95,1.42c-.21.28-.39.58-.62.84,0,.06-.16.21-.24.23s-.19-.09-.22-.23a1.55,1.55,0,0,1,.1-.6h0s0,0,0-.05h0c0-.2-.26-.5-.37-.25A8.87,8.87,0,0,1,45,136.24l-.11.1c0-.12,0-.24,0-.36a2.75,2.75,0,0,0-.14-.8c0-.13-.27-.33-.39-.16a13.69,13.69,0,0,1-2,2.72A2.93,2.93,0,0,1,42,138c-.14-.08.07-.79.1-.9.08-.32.19-.64.29-.95a4.15,4.15,0,0,0,.24-.78c0-.25-.38-.62-.46-.29,0,.13-.15.45-.27.85a19.76,19.76,0,0,1-1.66,2.81A6.42,6.42,0,0,1,37.88,141c-.26.14-.75.34-1,.14s-.26-.58-.27-.84a7.19,7.19,0,0,1,.28-2.05,12.29,12.29,0,0,0,2.56-1.81,8.78,8.78,0,0,0,1.94-2.14c.26-.48.42-1.26-.22-1.53-.44-.18-1,.13-1.38.34a6,6,0,0,0-1.41,1.09,8.13,8.13,0,0,0-1.76,3.22c-.06.19-.13.43-.2.71a5.5,5.5,0,0,1-3.26.54c-.06,0-.08.13,0,.14a5.33,5.33,0,0,0,3.18-.3c-.28,1.23-.44,2.87.71,3.18s2.54-1.12,3.16-1.94a13.07,13.07,0,0,0,1.23-2l.11-.15c0,.58.11,1,.67.9s1.09-.9,1.4-1.34.57-.84.84-1.27c.05.51.15,1.1.64,1s.9-.95,1.13-1.3.39-.61.56-.93a.62.62,0,0,0,.11.17c.41.44.9,0,1.16-.38a19.26,19.26,0,0,0,1.15-1.57,1,1,0,0,0,.49.55c.63.3,1.23-.22,1.59-.69a13.3,13.3,0,0,0,1.19-1.91.92.92,0,0,0,.44.61,1.46,1.46,0,0,0,1.48-.1C54.54,131.22,54.35,130.8,54.14,130.9Zm-13.83,2.47c.29-.15.9-.4.94.1a1.7,1.7,0,0,1-.4.86,11,11,0,0,1-1.72,1.83A14.56,14.56,0,0,1,37,137.8,6.91,6.91,0,0,1,40.31,133.37Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "43.7776px 135.697px"
    },
    id: "el5l8fe402rjy",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--diploma--inject-114",
    className: "animable",
    style: {
      transformOrigin: "46.56px 180.83px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-114",
    className: "animable",
    style: {
      transformOrigin: "46.56px 180.83px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "23.59 212.47 25.36 213.49 69.53 187.99 67.76 186.97 23.59 212.47",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "46.56px 200.23px"
    },
    id: "elvb9igs0unm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.76 186.97 25.36 211.45 25.36 174.69 67.76 150.21 67.76 186.97",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "46.56px 180.83px"
    },
    id: "elnxaqndfij2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3,146.13,23.59,173.68v42.87L71.3,189ZM69.53,188l-44.17,25.5V174.7l44.17-25.51Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "47.445px 181.34px"
    },
    id: "elof6kw9bv2v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.53 187.99 67.76 186.97 67.76 150.21 69.53 149.19 69.53 187.99",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "68.645px 168.59px"
    },
    id: "el58zzj75slma",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.3 146.13 69.53 145.11 21.82 172.66 23.59 173.68 71.3 146.13",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "46.56px 159.395px"
    },
    id: "elwntmj0b7jrr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.82 172.66 23.59 173.68 23.59 216.55 21.82 215.53 21.82 172.66",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "22.705px 194.605px"
    },
    id: "elgyvfh0be57b",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.45,180.79c1.64-.95,3-.18,3,1.72a6.63,6.63,0,0,1-3,5.17c-1.65.95-3,.18-3-1.73A6.58,6.58,0,0,1,59.45,180.79Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "59.45px 184.235px"
    },
    id: "el7z386fhpzr6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.35,173l22.45-13c.63-.36,1.13-.07,1.13.65v.06a2.49,2.49,0,0,1-1.13,2l-22.45,13c-.63.36-1.13.07-1.13-.65V175A2.49,2.49,0,0,1,35.35,173Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "46.575px 167.855px"
    },
    id: "elu6wcv9oiau",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.79,183.24l29.56-17.06c.62-.36,1.13-.2,1.13.36a2.27,2.27,0,0,1-1.13,1.68L31.77,185.29c-.63.36-1.13.2-1.12-.37A2.32,2.32,0,0,1,31.79,183.24Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "46.5649px 175.735px"
    },
    id: "elgrrx9xf8i0s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.79,187.32l29.56-17.07c.62-.36,1.13-.19,1.13.37a2.27,2.27,0,0,1-1.13,1.67L31.77,189.37c-.63.36-1.13.19-1.12-.37A2.32,2.32,0,0,1,31.79,187.32Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "46.5649px 179.81px"
    },
    id: "elilnuhs9pxi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.79,191.39l29.56-17.06c.62-.36,1.13-.2,1.13.37a2.27,2.27,0,0,1-1.13,1.67L31.77,193.45c-.63.36-1.13.19-1.12-.38A2.33,2.33,0,0,1,31.79,191.39Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "46.5649px 183.889px"
    },
    id: "elf5x1i3uw8xc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.14,189.51a1.7,1.7,0,0,1-.74.2c-.63,0-.57-.65-.55-1.09,0-.2-.27-.51-.42-.24-.38.69-.87,1.33-1.28,2-.25.41-.73,1.34-1.34,1.21-.25-.05-.33-.32-.33-.66a3.39,3.39,0,0,0,.39-1.85c0-.19-.35-.42-.45-.16a5.88,5.88,0,0,0-.38,1.69,10.63,10.63,0,0,1-.95,1.42c-.21.28-.39.58-.62.84,0,.06-.16.22-.24.23S47,193,47,192.87a1.58,1.58,0,0,1,.1-.6h0s0,0,0-.05h0c0-.2-.26-.5-.37-.25A8.66,8.66,0,0,1,45,194.85l-.11.1c0-.12,0-.24,0-.36a2.75,2.75,0,0,0-.14-.8c0-.13-.27-.33-.39-.15a14.29,14.29,0,0,1-2,2.72,3.8,3.8,0,0,1-.41.28c-.14-.07.07-.79.1-.9.08-.32.19-.63.29-1a4.15,4.15,0,0,0,.24-.78c0-.24-.38-.62-.46-.29,0,.13-.15.46-.27.86a20.22,20.22,0,0,1-1.66,2.8,6.42,6.42,0,0,1-2.31,2.23c-.26.14-.75.35-1,.14s-.26-.57-.27-.84a7.07,7.07,0,0,1,.28-2,13.08,13.08,0,0,0,2.56-1.81,9,9,0,0,0,1.94-2.15c.26-.47.42-1.25-.22-1.52-.44-.19-1,.12-1.38.33a6,6,0,0,0-1.41,1.09A8.1,8.1,0,0,0,36.58,196c-.06.18-.13.42-.2.7a5.5,5.5,0,0,1-3.26.54c-.06,0-.08.13,0,.14a5.33,5.33,0,0,0,3.18-.3c-.28,1.24-.44,2.87.71,3.19s2.54-1.12,3.16-1.95a13.07,13.07,0,0,0,1.23-2,.76.76,0,0,1,.11-.14c0,.57.11,1,.67.89s1.09-.9,1.4-1.34.57-.84.84-1.27c.05.52.15,1.1.64,1s.9-.95,1.13-1.3.39-.61.56-.92a.57.57,0,0,0,.11.16c.41.44.9,0,1.16-.37.38-.5.8-1,1.15-1.58a1,1,0,0,0,.49.56c.63.29,1.23-.23,1.59-.7a13.3,13.3,0,0,0,1.19-1.91.88.88,0,0,0,.44.61,1.43,1.43,0,0,0,1.48-.1C54.54,189.83,54.35,189.41,54.14,189.51ZM40.31,192c.29-.15.9-.4.94.1a1.7,1.7,0,0,1-.4.86,10.66,10.66,0,0,1-1.72,1.83A14.56,14.56,0,0,1,37,196.41,6.91,6.91,0,0,1,40.31,192Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "43.7495px 194.295px"
    },
    id: "eljusdawqmvfl",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-114",
    className: "animable",
    style: {
      transformOrigin: "254.921px 391.731px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-114",
    d: "M299.22,423l70.68,40.8a8.39,8.39,0,0,0,7.59,0l38.66-22.32c2.09-1.21,2.09-3.17,0-4.38l-70.68-40.81a8.39,8.39,0,0,0-7.59,0l-38.66,22.33C297.13,419.83,297.13,421.79,299.22,423Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "357.685px 430.045px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-114",
    d: "M229.38,412.11c17.09,9.87,44.81,9.87,61.9,0s17.09-25.87,0-35.74-44.81-9.87-61.9,0S212.29,402.24,229.38,412.11Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "260.33px 394.24px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-114",
    d: "M63.1,458.1c29.26,16.89,76.7,16.89,106,0s29.26-44.28,0-61.18-76.7-16.89-106,0S33.84,441.21,63.1,458.1Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "116.1px 427.508px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-114",
    d: "M442.54,440.07,248.1,327.81c-2.4-1.38-2.4-3.62,0-5l15.71-9.08a9.57,9.57,0,0,1,8.66,0L466.91,426c2.39,1.38,2.39,3.61,0,5l-15.71,9.07A9.57,9.57,0,0,1,442.54,440.07Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "357.501px 376.9px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Symbol--inject-114",
    className: "animable",
    style: {
      transformOrigin: "179.395px 335.355px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--medical-symbol--inject-114",
    className: "animable",
    style: {
      transformOrigin: "179.395px 335.355px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "205.56 324.95 216.88 308.97 206.58 292.94 195.3 286.43 192.82 289.93 183.47 284.51 164.03 295.74 164.03 314.33 152.21 311.31 141.91 339.24 153.24 345.76 141.91 361.74 152.21 377.77 163.49 384.29 165.96 380.8 175.32 386.2 194.76 374.97 194.76 356.38 206.58 359.4 216.88 331.48 205.56 324.95",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "179.395px 335.355px"
    },
    id: "elib18t3jk45",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elg9xs6hifepp"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "205.56 324.95 216.88 308.97 206.58 292.94 195.3 286.43 192.82 289.93 183.47 284.51 164.03 295.74 164.03 314.33 152.21 311.31 141.91 339.24 153.24 345.76 141.91 361.74 152.21 377.77 163.49 384.29 165.96 380.8 175.32 386.2 194.76 374.97 194.76 356.38 206.58 359.4 216.88 331.48 205.56 324.95",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "179.395px 335.355px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elbncdhsi52rv"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "192.82 289.93 194.76 291.03 194.76 309.62 206.58 292.94 195.3 286.43 192.82 289.93",
    style: {
      fill: "rgb(255, 193, 0)",
      opacity: 0.5,
      transformOrigin: "199.7px 298.025px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elej4fbgsspk9"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "152.21 311.31 163.49 317.82 175.32 320.84 164.03 314.33 152.21 311.31",
    style: {
      fill: "rgb(255, 193, 0)",
      opacity: 0.3,
      transformOrigin: "163.765px 316.075px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elfqqdh9uvn07"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "164.03 295.74 175.32 302.25 175.32 320.84 164.03 314.33 164.03 295.74",
    style: {
      fill: "rgb(255, 193, 0)",
      opacity: 0.5,
      transformOrigin: "169.675px 308.29px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elln9w79ddjjd"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "152.21 311.31 163.49 317.82 153.19 345.75 141.91 339.24 152.21 311.31",
    style: {
      fill: "rgb(255, 193, 0)",
      opacity: 0.5,
      transformOrigin: "152.7px 328.53px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eln6xbarf9nq9"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "166.69 349.2 153.19 345.75 141.91 361.74 153.19 368.25 166.69 349.2",
    style: {
      fill: "rgb(255, 193, 0)",
      opacity: 0.5,
      transformOrigin: "154.3px 357px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el6jf7xths6la"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "141.91 361.74 153.19 368.25 163.49 384.29 152.21 377.77 141.91 361.74",
    style: {
      fill: "rgb(255, 193, 0)",
      opacity: 0.65,
      transformOrigin: "152.7px 373.015px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elcim7uf89rn"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "175.32 386.2 165.96 380.8 175.32 367.6 175.32 386.2",
    style: {
      fill: "rgb(255, 193, 0)",
      opacity: 0.65,
      transformOrigin: "170.64px 376.9px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el8yi7h01cisb"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "216.88 331.48 203.38 328.02 205.56 324.95 216.88 331.48",
    style: {
      fill: "rgb(255, 193, 0)",
      opacity: 0.5,
      transformOrigin: "210.13px 328.215px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "198.62 328.6 212.9 308.45 205.48 296.9 193.23 314.17 191.35 313.08 191.35 295.03 176.84 303.4 176.84 323.63 163.98 320.34 155.5 343.33 167.69 346.45 169.57 347.54 155.29 367.69 162.72 379.24 174.96 361.97 176.84 363.05 176.84 381.11 191.35 372.74 191.35 352.51 204.22 355.8 212.7 332.81 200.5 329.68 198.62 328.6",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "184.095px 338.07px"
    },
    id: "elg3p0klnt5j5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,362l-12.24,17.27,1.26,2,12.86-18.15Zm29.26-6.17-12.87-3.29v20.23l-14.51,8.37v2.17l16.39-9.46V353.59l12.87,3.29,8.68-23.54-2.08-.54Zm-3.72-26.12,14.28-20.14L206.1,296l-.62.88,7.42,11.55L198.62,328.6Zm-7.27-35.74L191.35,295v18.06l1.88,1.08Zm-25.54,52.52-12.19-3.13-.21.56,14.28,3.65Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "185.075px 338.64px"
    },
    id: "ellgrg4vtn2se",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8z0bx2syrci"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175,362l-12.24,17.27,1.26,2,12.86-18.15Zm29.26-6.17-12.87-3.29v20.23l-14.51,8.37v2.17l16.39-9.46V353.59l12.87,3.29,8.68-23.54-2.08-.54Zm-3.72-26.12,14.28-20.14L206.1,296l-.62.88,7.42,11.55L198.62,328.6Zm-7.27-35.74L191.35,295v18.06l1.88,1.08Zm-25.54,52.52-12.19-3.13-.21.56,14.28,3.65Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "185.075px 338.64px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el2ajlstxk6fj"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "191.35 372.74 193.23 373.82 193.23 353.59 191.35 352.51 191.35 372.74",
    style: {
      fill: "rgb(255, 193, 0)",
      opacity: 0.35,
      transformOrigin: "192.29px 363.165px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ely4saxa6oz6"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "204.22 355.8 206.1 356.88 214.78 333.34 212.7 332.81 204.22 355.8",
    style: {
      fill: "rgb(255, 193, 0)",
      opacity: 0.35,
      transformOrigin: "209.5px 344.845px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el95bki8g3hoi"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "176.84 363.05 174.96 361.97 162.72 379.24 163.98 381.2 176.84 363.05",
    style: {
      fill: "rgb(255, 193, 0)",
      opacity: 0.35,
      transformOrigin: "169.78px 371.585px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ell2c6pqnvqmf"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "212.9 308.45 214.78 309.54 206.1 296.02 205.48 296.9 212.9 308.45",
    style: {
      fill: "rgb(255, 193, 0)",
      opacity: 0.35,
      transformOrigin: "210.13px 302.78px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eldmm0a4jehub"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "193.23 314.17 191.35 313.08 191.35 295.03 193.23 293.94 193.23 314.17",
    style: {
      fill: "rgb(255, 193, 0)",
      opacity: 0.35,
      transformOrigin: "192.29px 304.055px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elrpj1jy1wfc8"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "169.57 347.54 167.69 346.45 155.5 343.33 155.29 343.89 169.57 347.54",
    style: {
      fill: "rgb(255, 193, 0)",
      opacity: 0.35,
      transformOrigin: "162.43px 345.435px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M184,369.9h.11l-.06,4.72Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "184.055px 372.26px"
    },
    id: "elicug7hgr4mn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.26,355.85l0,4.74,0,2.82,0,4.74-.14,0,0-4.35,0-2.81-.05-5.16Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "184.165px 361.99px"
    },
    id: "el2iqe3ep20pp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.48,335.7l-.08,6.76-.11,10.31-.48-.12-.06-5.95,0-3.43-.08-7.43.62-.1Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "184.075px 344.235px"
    },
    id: "el6se25rg38ku",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.86,311.66a4.59,4.59,0,0,1-1.16,2.91l-.07,6.95,0,3-.08,7.4-.93,0-.07-6.38-.06-4.92-.05-5.32c-.68,0-1.16-.56-1.16-1.58a4.35,4.35,0,0,1,1.8-3.45C185.05,309.72,185.86,310.33,185.86,311.66Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "184.07px 320.994px"
    },
    id: "eldxzo85byvrl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.67,317.92a8.6,8.6,0,0,0-4.6,2l0,3.65a17.18,17.18,0,0,1,4-2.36s-.2,1.09.28,1.3a4.24,4.24,0,0,0,3.51-.51C193.79,321.11,193.12,318,189.67,317.92Zm1.1,2.7c-.23.12-.41,0-.41-.31a1,1,0,0,1,.41-.77c.22-.13.4,0,.4.31A1,1,0,0,1,190.77,320.62Zm-5.83,11.87-.43,0c-.31,0-.62,0-.91,0h-.44c-1.27,0-2.2-.42-2.2-1.82a8.17,8.17,0,0,1,2.12-5.29l0-3.8C180.32,324.3,178,328,178,331.87s2.6,3.84,5.22,3.44l.43-.06.86-.15.43-.08c2-.33,3.63-.49,3.63,1.19,0,1.91-1.77,4.08-3.71,6.38l0,2.22c2.49-2.94,5.35-6.2,5.35-9.53S187.42,332.31,184.94,332.49Zm-.23,21-.43-.09-.46-.1-.43-.11c-1.22-.33-2.23-.86-2.23-2.34,0-1.26.91-2.7,2.16-4.28l0-2.19c-1.88,2.29-3.54,4.66-3.54,7,0,2.86,1.89,3.34,3.66,3.63l.43.07.42.07.43.08c1,.22,1.75.57,1.75,1.63,0,1.33-.84,2.54-1.81,3.79l0,1.52c1.39-1.73,3-3.57,3-6.26C187.58,354.25,186.19,353.85,184.71,353.52Zm-.17,15.34a2.85,2.85,0,0,1-.42,0,.5.5,0,0,1-.13,0,1.31,1.31,0,0,1-.43-.16c-.58-.3-1-.95-1-2.23a5,5,0,0,1,.9-2.68v-1.54a7.29,7.29,0,0,0-1.73,4.33c0,1.65.74,2.56,1.8,2.74a3.15,3.15,0,0,0,.44,0h.11l.43-.06a4.34,4.34,0,0,0,1.29-.5A6.44,6.44,0,0,1,184.54,368.86Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "185.62px 343.609px"
    },
    id: "el51wvlg02t4a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eloayhqhay4w"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "175.32 302.25 194.76 291.03 183.47 284.51 164.03 295.74 175.32 302.25",
    style: {
      fill: "rgb(255, 193, 0)",
      opacity: 0.2,
      transformOrigin: "179.395px 293.38px"
    },
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clipboard--inject-114",
    className: "animable",
    style: {
      transformOrigin: "355.04px 227.18px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clip-board--inject-114",
    className: "animable",
    style: {
      transformOrigin: "355.04px 227.18px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-114",
    className: "animable",
    style: {
      transformOrigin: "355.04px 227.18px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.84,430.36l3.72-2.14a4.71,4.71,0,0,0,2.12-3.68V126.41a4.71,4.71,0,0,0-2.12-3.68L273.49,24a4.66,4.66,0,0,0-4.24,0l-3.73,2.15a4.68,4.68,0,0,0-2.12,3.67V327.92a4.7,4.7,0,0,0,2.12,3.68l171.07,98.76A4.68,4.68,0,0,0,440.84,430.36Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "355.04px 227.18px"
    },
    id: "el8muawlllqmt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7ks6gnmvqzs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.84,430.36l3.72-2.14a4.71,4.71,0,0,0,2.12-3.68V126.41a4.71,4.71,0,0,0-2.12-3.68L273.49,24a4.66,4.66,0,0,0-4.24,0l-3.73,2.15a4.68,4.68,0,0,0-2.12,3.67V327.92a4.7,4.7,0,0,0,2.12,3.68l171.07,98.76A4.68,4.68,0,0,0,440.84,430.36Z",
    style: {
      opacity: 0.3,
      transformOrigin: "355.04px 227.18px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elx71u0nwip88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.42,29.45c.15-1.1,1-1.5,2.1-.88l171.07,98.76a4.31,4.31,0,0,1,1.5,1.58l8-4.6a4.39,4.39,0,0,0-1.5-1.58L273.5,24a4.68,4.68,0,0,0-4.25,0l-3.73,2.14A4.77,4.77,0,0,0,263.42,29.45Z",
    style: {
      fill: "rgb(255, 193, 0)",
      opacity: 0.4,
      transformOrigin: "354.755px 76.1999px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el9nlq0vxwzw6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437,430.53a.35.35,0,0,0,.13.05l.22.08.08,0,.4.1h0a4.81,4.81,0,0,0,2.53-.21c.16-.06.32-.14.47-.21l3.72-2.15a4.73,4.73,0,0,0,2.12-3.68V126.41a4.31,4.31,0,0,0-.62-2.1l-8,4.6a4.32,4.32,0,0,1,.63,2.1V429.14a1.76,1.76,0,0,1-.33,1.12,1.1,1.1,0,0,1-1.13.36Z",
    style: {
      opacity: 0.15,
      transformOrigin: "441.835px 277.576px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clip--inject-114",
    className: "animable",
    style: {
      transformOrigin: "353.062px 83.42px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.22,80.68l71.7,41.4,4-2.3V108.72c0-1.4-.22-3.22-5.6-10.64s-5.53-10-8-13.34S370.42,78.87,367.26,71,363.81,51,355.05,46a7.84,7.84,0,0,0-3.84-1.24,3.94,3.94,0,0,0-2,.55l-3.66,2.11-.33.19,1.05,1.55c-1.21,2.66-2,5.88-3.39,7.71a5.61,5.61,0,0,1-4.07,2.42c-2.25.26-4.5-.62-6-.25a4.12,4.12,0,0,0-1,.42h0l-4,2.3h0l.27.33a16.14,16.14,0,0,1-1.56.64c-.48.15-1,.31-1.64.45a13.19,13.19,0,0,0-4.12,1.46l-3.53,2-.32.19Zm65.67,25.21c0-1.44.75-2.17,1.68-1.63a4.5,4.5,0,0,1,1.7,3.59c0,1.44-.77,2.15-1.7,1.62A4.45,4.45,0,0,1,380.89,105.89Zm-36.2-41c0-4.63,2.06-7.3,4.85-6.76a3.59,3.59,0,0,1,5.51-1.68c3.53,2,6.39,8.09,6.39,13.52,0,4.61-2.07,7.3-4.84,6.76-1.11,2.28-3.17,3.05-5.52,1.69C347.54,76.39,344.69,70.34,344.69,64.9ZM325.57,74c0-1.45.76-2.17,1.7-1.63A4.47,4.47,0,0,1,329,75.92c0,1.43-.76,2.16-1.69,1.62A4.44,4.44,0,0,1,325.57,74Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "353.07px 83.42px"
    },
    id: "elktxxuyi9f0f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elekvws8n5cph"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.94,111.45l7.71-4.45a5.61,5.61,0,0,1,.25,1.72v11.06l-4,2.3-4-2.3Z",
    style: {
      fill: "rgb(55, 71, 79)",
      opacity: 0.5,
      transformOrigin: "386.9px 114.54px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elnk0o1dukom"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375,97.65l-4-9.2,6.33-3.71h0c1.86,2.57,2.4,4.65,4.9,8.73Z",
    style: {
      fill: "rgb(55, 71, 79)",
      opacity: 0.5,
      transformOrigin: "376.615px 91.195px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eldae7lujc7c7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359,79.25l-.52-2.68c1.76-.74,2.93-3.12,2.93-6.59,0-4.61-2.06-9.66-4.85-12.33l5.52-3.19c2.36,5.36,3.23,11.69,5.15,16.5.41,1,.84,1.94,1.28,2.8Z",
    style: {
      fill: "rgb(55, 71, 79)",
      opacity: 0.5,
      transformOrigin: "362.535px 66.855px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M315.22,69.62V80.68l71.7,41.4V111c0-1.4-.21-3.21-5.59-10.64s-5.54-9.94-8-13.34-6.89-5.86-10-13.78-3.45-19.91-12.21-25c-2.43-1.4-4.2-1.51-5.57-.88l-.33.19c-3.3,1.95-4.11,8.58-6.32,11.56a1.25,1.25,0,0,0-.09.12c-3.16,4.09-7.56,1.46-10,2a4,4,0,0,0-1.07.43,8.06,8.06,0,0,0-1.29,1,11.52,11.52,0,0,1-5.61,2.74,16.05,16.05,0,0,0-3.68,1.2l-.32.19A2.79,2.79,0,0,0,315.22,69.62Zm61.69,38.57c0-1.44.75-2.18,1.69-1.64a4.51,4.51,0,0,1,1.69,3.59c0,1.44-.76,2.17-1.69,1.63A4.46,4.46,0,0,1,376.91,108.19ZM344.69,64.9c0-4.63,2.06-7.3,4.85-6.76a5.36,5.36,0,0,1,1.54.61c3.53,2,6.39,8.1,6.39,13.53a10.2,10.2,0,0,1-.87,4.46c-1.11,2.28-3.17,3.05-5.52,1.69C347.54,76.39,344.69,70.34,344.69,64.9ZM321.6,76.26c0-1.44.76-2.17,1.69-1.63A4.44,4.44,0,0,1,325,78.21c0,1.44-.75,2.16-1.69,1.62A4.46,4.46,0,0,1,321.6,76.26Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "351.062px 84.5362px"
    },
    id: "el3vxrbsuxn4h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.69,64.9c0,5.44,2.85,11.49,6.39,13.53,2.35,1.36,4.41.59,5.52-1.69a4.89,4.89,0,0,1-1.55-.61c-3.53-2-6.39-8.09-6.39-13.52a10.21,10.21,0,0,1,.88-4.47C346.75,57.6,344.69,60.27,344.69,64.9Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "350.645px 68.587px"
    },
    id: "elmlb27ou0lzi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.6,111.77c.93.53,1.69-.19,1.69-1.63a4.51,4.51,0,0,0-1.69-3.59c-.94-.53-1.69.2-1.69,1.64a4.44,4.44,0,0,0,1.69,3.58",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "378.6px 109.161px"
    },
    id: "elzeik1no6m0j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.29,79.84c.94.54,1.7-.19,1.7-1.62a4.47,4.47,0,0,0-1.7-3.59c-.93-.54-1.69.2-1.69,1.63a4.47,4.47,0,0,0,1.69,3.58",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "323.295px 77.2356px"
    },
    id: "elpnbtn25eqo",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Paper--inject-114",
    className: "animable",
    style: {
      transformOrigin: "349.065px 233.565px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.49,145.22,276.63,59.28a2.8,2.8,0,0,0-2.55,0l-1.43.83a2.81,2.81,0,0,0-1.28,2.21V319.7a2.82,2.82,0,0,0,1.28,2.21L421.5,407.85a2.8,2.8,0,0,0,2.55,0l1.44-.83a2.84,2.84,0,0,0,1.27-2.21V147.43A2.84,2.84,0,0,0,425.49,145.22Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "349.065px 233.565px"
    },
    id: "el1ka24c5famc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.81,408a1.71,1.71,0,0,0,.47.12l.24,0a3.4,3.4,0,0,0,.78,0,1.8,1.8,0,0,0,.47-.12l.28-.14,1.44-.82a2.85,2.85,0,0,0,1.27-2.21V147.44a2.61,2.61,0,0,0-.37-1.26l-4,2.3a2.72,2.72,0,0,1,.37,1.25V407.11C422.78,407.81,422.37,408.15,421.81,408Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "424.285px 277.161px"
    },
    id: "elz86mlhnmup",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.65,60.11l1.43-.83a2.8,2.8,0,0,1,2.55,0l148.86,85.94a2.84,2.84,0,0,1,1.27,2.21v42.44l-4,2.31L271.37,104.77V62.32A2.81,2.81,0,0,1,272.65,60.11Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "349.065px 125.576px"
    },
    id: "elf79zozo305",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el53okflv4jqq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.65,60.11l1.43-.83a2.8,2.8,0,0,1,2.55,0l148.86,85.94a2.84,2.84,0,0,1,1.27,2.21v42.44l-4,2.31L271.37,104.77V62.32A2.81,2.81,0,0,1,272.65,60.11Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "349.065px 125.576px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M271.42,61.93c.16-.52.65-.69,1.22-.35L421.5,147.52a2.6,2.6,0,0,1,.91.95l4-2.29a2.5,2.5,0,0,0-.9-1L276.63,59.28a2.78,2.78,0,0,0-2.54,0l-1.45.83A2.86,2.86,0,0,0,271.42,61.93Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "348.915px 103.721px"
    },
    id: "elhwco3za57c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "els6bpzeskft"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.42,61.93c.16-.52.65-.69,1.22-.35L421.5,147.52a2.6,2.6,0,0,1,.91.95l4-2.29a2.5,2.5,0,0,0-.9-1L276.63,59.28a2.78,2.78,0,0,0-2.54,0l-1.45.83A2.86,2.86,0,0,0,271.42,61.93Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "348.915px 103.721px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M426.76,147.43v42.45l-4,2.3V149.73a2.79,2.79,0,0,0-.37-1.26l4-2.29A2.54,2.54,0,0,1,426.76,147.43Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "424.575px 169.18px"
    },
    id: "elwkzkupx9qkp",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M315.74,181.69l7.61-11.48-5.72-3.3-5,7.69-5.84-16.34a3.88,3.88,0,0,0,2.53-2.33,12,12,0,0,0,.93-5,18.49,18.49,0,0,0-9.37-16.16l-7.25-4.19V162.5l4.72,2.73V155.08l3.15,1.82,8,20.73-7.84,12,5.85,3.38,5.16-8,4.86,13.82,6.08,3.51ZM298.36,149v-9.63l3.38,2a6.25,6.25,0,0,1,2.89,3.25,10.77,10.77,0,0,1,.75,3.75,3.92,3.92,0,0,1-.88,2.72q-.87,1-2.79-.12Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "308.62px 166.46px"
    },
    id: "el6o7fim25pz7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.44 212.03 346.25 174.39 346.25 160.97 411.44 198.6 411.44 212.03",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "378.845px 186.5px"
    },
    id: "el085i2om0wl4p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.44,226.42l-65.19-37.64a3.1,3.1,0,0,1-1.18-2.5c0-1,.53-1.51,1.18-1.14l65.19,37.64a3.13,3.13,0,0,1,1.18,2.5C412.62,226.29,412.09,226.8,411.44,226.42Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "378.845px 205.783px"
    },
    id: "el4drg8tch1bo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.44,238.69l-65.19-37.64a3.13,3.13,0,0,1-1.18-2.5c0-1,.53-1.52,1.18-1.14l65.19,37.64a3.13,3.13,0,0,1,1.18,2.5C412.62,238.56,412.09,239.06,411.44,238.69Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "378.845px 218.049px"
    },
    id: "elmnrzzts2b1i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.44,251l-65.19-37.64a3.1,3.1,0,0,1-1.18-2.5c0-1,.53-1.51,1.18-1.13l65.19,37.63a3.14,3.14,0,0,1,1.18,2.51C412.62,250.82,412.09,251.33,411.44,251Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "378.845px 230.352px"
    },
    id: "elz8u1cez5v8p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.44,276.38,286.06,204a3.14,3.14,0,0,1-1.18-2.51c0-1,.53-1.51,1.18-1.13l125.38,72.38a3.13,3.13,0,0,1,1.18,2.5C412.62,276.25,412.09,276.76,411.44,276.38Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "348.75px 238.37px"
    },
    id: "el8inpxkl7rmw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.44,291.74,286.06,219.36a3.14,3.14,0,0,1-1.18-2.51c0-1,.53-1.51,1.18-1.13L411.44,288.1a3.13,3.13,0,0,1,1.18,2.5C412.62,291.61,412.09,292.12,411.44,291.74Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "348.75px 253.73px"
    },
    id: "elroatiu082p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.44,307.1,286.06,234.72a3.14,3.14,0,0,1-1.18-2.51c0-1,.53-1.51,1.18-1.13l125.38,72.38a3.14,3.14,0,0,1,1.18,2.51C412.62,307,412.09,307.48,411.44,307.1Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "348.75px 269.092px"
    },
    id: "elqoahxugixl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.44,322.46,286.06,250.08a3.14,3.14,0,0,1-1.18-2.51c0-1,.53-1.51,1.18-1.13l125.38,72.38a3.14,3.14,0,0,1,1.18,2.51C412.62,322.33,412.09,322.84,411.44,322.46Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "348.75px 284.45px"
    },
    id: "el0aramdxfqf69",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.44,357.25,286.06,284.86a1,1,0,0,1-.39-.83c0-.33.18-.5.39-.38L411.44,356a1,1,0,0,1,.39.83C411.83,357.21,411.66,357.38,411.44,357.25Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "348.75px 320.452px"
    },
    id: "el7r7ctsociie",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.93,322.54c-4.52-2.62-8.21-10.41-8.21-17.38s3.69-10.51,8.21-7.9,8.21,10.41,8.21,17.38S299.46,325.15,294.93,322.54Zm0-24.07c-4.09-2.36-7.42.85-7.42,7.14s3.33,13.35,7.42,15.71,7.42-.84,7.42-7.14S299,300.84,294.93,298.47Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "294.93px 309.9px"
    },
    id: "elyw3h8d47fmp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.63,313.19c0,4.84-2.55,7.3-5.7,5.48s-5.7-7.22-5.7-12.06,2.56-7.3,5.7-5.48S300.63,308.34,300.63,313.19Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "294.93px 309.9px"
    },
    id: "elz6a3t4vsk2b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.48 337.01 311.57 313.97 311.57 310.71 351.48 333.75 351.48 337.01",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "331.525px 323.86px"
    },
    id: "eli57d6qf8y99",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.48 344.17 311.57 321.13 311.57 317.87 351.48 340.91 351.48 344.17",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "331.525px 331.02px"
    },
    id: "ela3kd2y3d1cp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.48 351.33 311.57 328.29 311.57 325.04 351.48 348.08 351.48 351.33",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "331.525px 338.185px"
    },
    id: "elhwjdvv609i8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.15,379.77c-.12.64-.68.5-1.08.05a7.14,7.14,0,0,1-.94-1.71,36.8,36.8,0,0,1-1.28-3.47,33.91,33.91,0,0,1-1.28-6.14c0-.45-.08-.89-.13-1.34-.09-.75-.95-1.37-.89-.53,0,.47.08.94.13,1.42a27,27,0,0,1-.08,5.34,10.94,10.94,0,0,1-1.51,5c-.36.46-.86.85-1.45.62s-1.28-1.45-1.71-2.48a33,33,0,0,1-1.28-3.7,6.27,6.27,0,0,0,.37-.68,23.55,23.55,0,0,0,1.71-7.23c.22-2.15.47-5.26-1.11-7.45-3.35-4.64-3.28,6.16-3,8.92a38.55,38.55,0,0,0,1.07,5.8,2.49,2.49,0,0,1-.55.53c-.54.35-1.18.33-1.84-.43a4.06,4.06,0,0,1-1-2.34l.06-.62c0-.55-.7-1.32-.8-.78,0,.05,0,.09,0,.14h0c0,.17,0,.34-.05.51a20.12,20.12,0,0,1-.76-2.76c-.09-.49-.66-1.06-.81-.65l-.9,2.51a12.56,12.56,0,0,1-.28-4.43c.08-.64-.75-1.47-.9-.9a9.37,9.37,0,0,1-1.37,3.37,1.46,1.46,0,0,1-2.37-.05l-.11-.13c.26-.38.51-.79.74-1.21a6.28,6.28,0,0,0,1.19-4.43c-.32-1.79-1.55-3.15-2.38-2.48-1.29,1-2,4.61-.82,7.52-1,1.26-2.31,2.06-3.92,1.51s-3.4-2.5-4.1-5.36a12.84,12.84,0,0,1-.38-3.36,8.85,8.85,0,0,0,2.39.73,5.12,5.12,0,0,0,5.55-2.83,5.34,5.34,0,0,0,.31-4.66,4.53,4.53,0,0,0-3-3c-2.24-.4-4.15,1.52-5.2,4a13.53,13.53,0,0,0-1,4.12,26.82,26.82,0,0,1-5.06-3.54c-.47-.4-.53.46-.1.87a28.09,28.09,0,0,0,5.11,3.87,14.62,14.62,0,0,0,.64,4.53c1.07,3.53,3.46,5.79,5.46,6.24,1.64.37,3-.44,4-1.73,1,1.32,2.21,1.69,3.1,1.25a3.17,3.17,0,0,0,1.31-1.58,17.58,17.58,0,0,0,.84,3.38c.15.44.65.82.78.45l.85-2.43a21.19,21.19,0,0,0,1.14,3.09c.12.24.39.47.56.44a5.85,5.85,0,0,0,1.67,2.26,1.65,1.65,0,0,0,2.39-.17c.07.22.12.44.19.65.76,2.3,1.89,5.36,3.51,6,1.82.77,2.79-1.74,3.29-3.81a22.51,22.51,0,0,0,.51-3.45c.29,1.12.63,2.24,1,3.34a16.26,16.26,0,0,0,2,4.25c.8,1,1.77,1.21,2,0C408.75,380.14,408.23,379.33,408.15,379.77Zm-32.94-26c.82-2.09,2.23-3.57,3.92-3.83.83-.13,2,.18,2.65,1.88a4,4,0,0,1-.66,3.71c-1.65,2.5-4.1,2.6-6.71,1.54A13,13,0,0,1,375.21,353.81Zm8.52,6.26c.18-.34.56-1.14,1-.64a2.79,2.79,0,0,1,.16,2.29,13.1,13.1,0,0,1-1.56,3.06A7.25,7.25,0,0,1,383.73,360.07ZM396,370.3a26.35,26.35,0,0,1-.09-11.72c.21-.76.61-1.32,1.28-.47a5.74,5.74,0,0,1,.85,3.31,26.78,26.78,0,0,1-.73,6.48,17.19,17.19,0,0,1-1.07,3.41C396.17,371,396.08,370.64,396,370.3Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "388.277px 364.994px"
    },
    id: "elzn68lsr3mdr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--clip--inject-114",
    className: "animable",
    style: {
      transformOrigin: "347.95px 99.2691px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.89,86.37s1.43,5.54,1.92,8.51c0,0,0,0,0,0s0,0,0,0a1.92,1.92,0,0,0,.78,1.2l85.91,49.55,1.6.91s0,0,0,0h0a.12.12,0,0,0,.13,0c.13-.08.19-.28.14-.56,0,0,0,0,0-.06-1.5-8.11-3.71-14.66-11.52-21.16l-12.49-9.36s-3.34-3.15-3.91-6.42l-.78-4.38-1.45-8.56s-.21-2.52-3.32-5.56-8.46-11.23-9.4-16.56c-1.49-8.46-7.6-17.88-13.66-21.05a8,8,0,0,0-3.65-1,4.23,4.23,0,0,0-2.19.56l-3.86,2.21-.17.1h0c0,.5-.74,16.74-3.26,16.8a2.74,2.74,0,0,0-.43,0,1.72,1.72,0,0,0-.65.23l-3.89,2.25-.09.05,5.19,11.47c.58,3.26-1.3,3.58-2.23,3.2l-1.73-.69c-2.39-1-4.39-1.93-9-4a4.31,4.31,0,0,0-4-.11l-4,2.29ZM333.73,60a3.23,3.23,0,0,1,1.65-2.25c.89-.41,11.84,18.37,10.64,19.32a2.93,2.93,0,0,1-2.81.36c-.63,2.36-2.5,3.2-5.07,1.85-3.73-2-7.48-7.75-8.4-12.94C328.92,61.68,330.66,59.08,333.73,60Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "349.134px 99.2142px"
    },
    id: "ela8ok9sghno",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elk08z201py6h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382,134l6.26-3.61c3.64,4.78,5.09,9.81,6.17,15.64,0,0,0,.05,0,.06,0,.28,0,.48-.14.56a.12.12,0,0,1-.13,0h0s0,0,0,0h0l-4.94-3.91Z",
    style: {
      fill: "rgb(55, 71, 79)",
      opacity: 0.5,
      transformOrigin: "388.215px 138.53px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el99ggq9s7luw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.89,110.46l-8.82,5.09-3-17.9L363,93.06a7.56,7.56,0,0,1,1.25,3l1.45,8.56.78,4.38A7.38,7.38,0,0,0,366.89,110.46Z",
    style: {
      fill: "rgb(55, 71, 79)",
      opacity: 0.5,
      transformOrigin: "360.98px 104.305px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elauqu9kr77n9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.34,63a34.33,34.33,0,0,1,4.19,11,27.32,27.32,0,0,0,3.12,7.8l-7.57,4.37-3.77-8.69a2.91,2.91,0,0,0,2.71-.38c.62-.49-2-5.69-4.76-10.57Z",
    style: {
      fill: "rgb(55, 71, 79)",
      opacity: 0.5,
      transformOrigin: "347.955px 74.585px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M301.47,92.07s3.48,3.29,3.69,3.41,1.21.68,1.21.68l86.15,49.53,1.6.91h0c-.3-.3-5-3.93-5-3.93a30,30,0,0,0-10.27-15.54l-12.47-9.36s-3.36-3.16-3.93-6.43l-.77-4.37-1.45-8.57s-.21-2.51-3.32-5.55-8.46-11.23-9.41-16.57c-1.49-8.45-7.6-17.87-13.65-21.05-2.29-1.2-4.26-1.33-5.72-.56l-.17.11c-2.27,1.33-3.26,4.91-2.36,10a8.93,8.93,0,0,1-1.33,6.81,4.87,4.87,0,0,1-3.55,2.27,2.39,2.39,0,0,0-1,.21l-.09.05c-1.25.71-.76,2.58-.76,2.58l1.19,6.82.78,4.37c0,.07,0,.14,0,.21.48,3.07-1.34,3.36-2.24,3-3.37-1.34-5.08-2.16-10.76-4.66a4.31,4.31,0,0,0-4-.13l-.06,0C302.44,87.23,301.62,89.24,301.47,92.07ZM333.73,60a6.13,6.13,0,0,1,1.08.46c3.73,1.94,7.49,7.74,8.41,12.94a10,10,0,0,1,0,4c-.63,2.36-2.5,3.2-5.07,1.85-3.73-2-7.48-7.75-8.4-12.94C328.92,61.68,330.66,59.08,333.73,60Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "347.795px 100.394px"
    },
    id: "elukuap4vqx4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.74,66.35c.92,5.19,4.67,11,8.4,12.94,2.57,1.35,4.44.51,5.07-1.85a7.9,7.9,0,0,1-1.09-.45c-3.73-1.95-7.48-7.75-8.4-12.95a9.82,9.82,0,0,1,0-4C330.66,59.08,328.92,61.68,329.74,66.35Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "336.374px 69.8887px"
    },
    id: "elrg092dswzah",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.34,60.23l.34,0a6.16,6.16,0,0,1,1,.44c3.65,1.9,7.37,7.63,8.28,12.76a9.74,9.74,0,0,1,0,3.89,3.84,3.84,0,0,1-2.6,1.66c-1.6,0-7.37-5.83-8.27-8.32-.63-1.79-2.11-7.39-.57-9.58a2.05,2.05,0,0,1,1.8-.87h0m0-.24c-4.4,0-2.37,8.22-1.46,10.77s6.75,8.49,8.47,8.49h0a4.17,4.17,0,0,0,2.82-1.81,10,10,0,0,0,0-4c-.92-5.2-4.68-11-8.41-12.94a6.13,6.13,0,0,0-1.08-.46,2.61,2.61,0,0,0-.39,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "336.973px 69.6px"
    },
    id: "elyl8teakx46h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.13,146.61,306.37,96.16l-1.21-.67c-.21-.13-3.68-3.42-3.68-3.42l87.68,50.61S394.48,146.79,394.13,146.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "347.813px 119.343px"
    },
    id: "elxb5otakdhi8",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Medicines--inject-114",
    className: "animable",
    style: {
      transformOrigin: "316.34px 362.578px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Capsules--inject-114",
    className: "animable",
    style: {
      transformOrigin: "359.171px 428.344px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.17,422.67l66.48,38.39a7.88,7.88,0,0,0,7.14,0l36.37-21c2-1.13,2-3,0-4.12l-66.49-38.38a7.86,7.86,0,0,0-7.13,0l-36.37,21C302.2,419.69,302.2,421.54,304.17,422.67Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "359.176px 429.31px"
    },
    id: "eld7uj0ikhq2d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.16,420.74l66.49,38.39a7.88,7.88,0,0,0,7.14,0l36.37-21c2-1.14,2-3,0-4.12l-66.49-38.39a7.94,7.94,0,0,0-7.14,0l-36.37,21C302.19,417.76,302.19,419.6,304.16,420.74Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "359.171px 427.379px"
    },
    id: "ely3394iicx4g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.79,459.13l32.8-18.94h0c-10.33,5.29-29.95,16.61-32.85,17.74s-4.61,1.63-10-1.49-59.9-33.58-59.9-33.58l62.82,36.27A7.88,7.88,0,0,0,377.79,459.13Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "359.215px 441.421px"
    },
    id: "elfjuppchtw66",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,446.07a1,1,0,0,1-.89,0l-66.27-38.27c-.26-.14-.27-.37,0-.51a1,1,0,0,1,.89,0L394,445.55C394.27,445.7,394.28,445.93,394,446.07Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "360.424px 426.68px"
    },
    id: "elny2icrhtuk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1owddi0nblo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.63,410.88h0a4,4,0,0,0,.66.31l.26.1a7.84,7.84,0,0,0,6-.54l6.25-3.61,0,0a4.46,4.46,0,0,0,.18-7.82,4.9,4.9,0,0,0-.66-.31l-.26-.09a7.86,7.86,0,0,0-6,.53l-6.25,3.6-.05,0a4.52,4.52,0,0,0-1.81,1.72,4.46,4.46,0,0,0,1.64,6.1Z",
    style: {
      fill: "rgb(250, 250, 250)",
      mixBlendMode: "hard-light",
      opacity: 0.7,
      transformOrigin: "347.279px 405.104px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M354,403.15a7.63,7.63,0,0,0-6.91.13l-6.25,3.61c-2,1.13-2.07,2.92-.22,4a7.62,7.62,0,0,0,6.91-.13l6.25-3.61C355.76,406,355.86,404.22,354,403.15Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "347.308px 407.021px"
    },
    id: "elzup9iw47fmn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.74,405.21a4.45,4.45,0,0,0-1.72-5.92,4.9,4.9,0,0,0-.66-.31l-.26-.09a8.09,8.09,0,0,0-5.23.16c2.93-.3,4.74-.38,6.58,1.16A4.51,4.51,0,0,1,355.74,405.21Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "352.059px 401.871px"
    },
    id: "elg6122hakc7i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.61,402.22a1.84,1.84,0,0,1,1.85.19,5.76,5.76,0,0,1,2.61,4.52,1.84,1.84,0,0,1-.77,1.69l-3.36,1.93a3.7,3.7,0,0,1-3.7-6.4Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "344.307px 406.511px"
    },
    id: "elovg9crpushf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.24,399.56a3.7,3.7,0,1,1,3.7,6.4l-4.64,2.66a1.84,1.84,0,0,0,.77-1.69,5.76,5.76,0,0,0-2.61-4.52,1.84,1.84,0,0,0-1.85-.19Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "349.772px 403.798px"
    },
    id: "elco971g7tfm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elppcwht4wi2q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.52,403a1.41,1.41,0,0,0-1.93-.52l-5.6,3.22a5.35,5.35,0,0,0,1.85,1.95l.22.12,4.95-2.84A1.42,1.42,0,0,0,353.52,403Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "349.849px 405.03px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M344.61,402.22a1.84,1.84,0,0,1,1.85.19,5.76,5.76,0,0,1,2.61,4.52,1.84,1.84,0,0,1-.77,1.69l-3.36,1.93a3.7,3.7,0,0,1-3.7-6.4Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "344.307px 406.511px"
    },
    id: "elsu5sc2qbbl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8x84ljmli1v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.07,406.93a5.76,5.76,0,0,0-2.61-4.52,1.84,1.84,0,0,0-1.85-.19l.26-.15.2-.11a1.81,1.81,0,0,1,1.85.18,5.78,5.78,0,0,1,2.61,4.52,1.84,1.84,0,0,1-.76,1.69l-.47.27A1.84,1.84,0,0,0,349.07,406.93Z",
    style: {
      opacity: 0.1,
      transformOrigin: "347.075px 405.203px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M341.6,410.73h0a3.69,3.69,0,0,1-.36-6.58l3.37-1.93a1.84,1.84,0,0,1,1.85.19,4.41,4.41,0,0,1,.89.7l-5.61,3.23C339.9,407.41,340.56,410.1,341.6,410.73Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "343.369px 406.392px"
    },
    id: "elygxbwhiizw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.11,409.55a1.41,1.41,0,0,1,.52-1.93l5.67-3.27a5.41,5.41,0,0,1,.77,2.58,2,2,0,0,1,0,.25l-5,2.89A1.41,1.41,0,0,1,342.11,409.55Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "345.497px 407.311px"
    },
    id: "elysj73zzzmy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbbav88i753s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.49,401.33a1.54,1.54,0,0,1,.08.19.88.88,0,0,1,.05.15.75.75,0,0,1,0,.16l0,.17s0,.06,0,.09a3.25,3.25,0,0,1,.06.76v0a2.46,2.46,0,0,1,0,.28h0c0-1.21-2-3.13-3.87-2.06l-3.54,2a4.41,4.41,0,0,0-.89-.7,1.84,1.84,0,0,0-1.85-.19l4.63-2.66a3.69,3.69,0,0,1,5.05,1.35c.06.1.11.2.16.3S354.48,401.29,354.49,401.33Z",
    style: {
      opacity: 0.1,
      transformOrigin: "349.607px 401.076px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elvrt7sp9a8eh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.31,424.46h0a4.9,4.9,0,0,0,.66.31l.26.1a7.87,7.87,0,0,0,6-.54l6.25-3.61,0,0a4.4,4.4,0,0,0,1.8-1.73,4.45,4.45,0,0,0-1.63-6.09,5,5,0,0,0-.66-.31l-.26-.09a7.88,7.88,0,0,0-6,.53l-6.25,3.61-.05,0a4.46,4.46,0,0,0-.18,7.82Z",
    style: {
      fill: "rgb(250, 250, 250)",
      mixBlendMode: "hard-light",
      opacity: 0.7,
      transformOrigin: "323.952px 418.684px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M330.7,416.73a7.68,7.68,0,0,0-6.92.13l-6.25,3.61c-2,1.14-2.07,2.92-.22,4a7.65,7.65,0,0,0,6.92-.13l6.25-3.61C332.45,419.59,332.55,417.8,330.7,416.73Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "324px 420.602px"
    },
    id: "elsj3a83cotuc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.42,418.8a4.46,4.46,0,0,0-1.72-5.93,5,5,0,0,0-.66-.31l-.26-.09a8.06,8.06,0,0,0-5.22.16c2.93-.29,4.73-.38,6.57,1.16A4.53,4.53,0,0,1,332.42,418.8Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "328.744px 415.456px"
    },
    id: "ellk45t56lces",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.29,415.81a1.81,1.81,0,0,1,1.85.18,5.78,5.78,0,0,1,2.61,4.52,1.84,1.84,0,0,1-.76,1.69l-3.37,1.93a3.69,3.69,0,1,1-3.69-6.4Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "320.917px 420.132px"
    },
    id: "els0dz3t31izo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.92,413.14a3.7,3.7,0,1,1,3.7,6.4L325,422.2a1.84,1.84,0,0,0,.76-1.69,5.78,5.78,0,0,0-2.61-4.52,1.81,1.81,0,0,0-1.85-.18Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "326.457px 417.378px"
    },
    id: "elcdvtyssur8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eldzmc5iyay9s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.21,416.57a1.42,1.42,0,0,0-1.94-.52l-5.6,3.22a5.44,5.44,0,0,0,1.85,2l.23.12,4.94-2.84A1.41,1.41,0,0,0,330.21,416.57Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "326.546px 418.625px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M321.29,415.81a1.81,1.81,0,0,1,1.85.18,5.78,5.78,0,0,1,2.61,4.52,1.84,1.84,0,0,1-.76,1.69l-3.37,1.93a3.69,3.69,0,1,1-3.69-6.4Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "320.917px 420.132px"
    },
    id: "elg9zk7mhk4vf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elkus6ce4d3h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.75,420.51a5.78,5.78,0,0,0-2.61-4.52,1.81,1.81,0,0,0-1.85-.18l.27-.16.2-.11a1.84,1.84,0,0,1,1.84.18,5.75,5.75,0,0,1,2.61,4.52,1.83,1.83,0,0,1-.76,1.69l-.46.27A1.84,1.84,0,0,0,325.75,420.51Z",
    style: {
      opacity: 0.1,
      transformOrigin: "323.755px 418.787px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M318.28,424.31h0a3.69,3.69,0,0,1-.35-6.58l3.36-1.92a1.81,1.81,0,0,1,1.85.18,4.2,4.2,0,0,1,.9.7l-5.61,3.24C316.59,421,317.24,423.68,318.28,424.31Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "320.057px 419.973px"
    },
    id: "elu7saaaeazbk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.79,423.13a1.42,1.42,0,0,1,.52-1.93l5.67-3.27a5.3,5.3,0,0,1,.77,2.58,2,2,0,0,1,0,.25l-5,2.89A1.42,1.42,0,0,1,318.79,423.13Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "322.179px 420.89px"
    },
    id: "el0wjfm9baldoi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8dkyexm4nsc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.18,414.91c0,.06.05.13.08.2s0,.09,0,.14,0,.11.05.16,0,.11,0,.17,0,.06,0,.09a4.87,4.87,0,0,1,.06.76v0c0,.09,0,.18,0,.27h0c0-1.21-2-3.12-3.87-2.06l-3.54,2a4.2,4.2,0,0,0-.9-.7,1.81,1.81,0,0,0-1.85-.18l4.63-2.67a3.71,3.71,0,0,1,5.06,1.35l.15.31A1.17,1.17,0,0,1,331.18,414.91Z",
    style: {
      opacity: 0.1,
      transformOrigin: "326.29px 414.647px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el762c8djga88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.36,420.54h0a4.39,4.39,0,0,0,.66.31l.26.1a7.84,7.84,0,0,0,6-.54l6.26-3.61,0,0a4.45,4.45,0,0,0-.48-8.13l-.26-.09a7.83,7.83,0,0,0-6,.53l-6.26,3.61,0,0a4.45,4.45,0,0,0-.18,7.82Z",
    style: {
      fill: "rgb(250, 250, 250)",
      mixBlendMode: "hard-light",
      opacity: 0.7,
      transformOrigin: "364.04px 414.763px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M370.75,412.81a7.65,7.65,0,0,0-6.92.13l-6.25,3.61c-2,1.13-2.07,2.92-.22,4a7.62,7.62,0,0,0,6.91-.13l6.26-3.61C372.5,415.66,372.59,413.88,370.75,412.81Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "364.048px 416.681px"
    },
    id: "el45d9r3iuhti",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.47,414.88a4.46,4.46,0,0,0-1.72-5.93,4.39,4.39,0,0,0-.66-.31l-.26-.09a8.06,8.06,0,0,0-5.22.16c2.93-.3,4.73-.38,6.57,1.16A4.53,4.53,0,0,1,372.47,414.88Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "368.794px 411.536px"
    },
    id: "el4o56lb8bd7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.34,411.88a1.84,1.84,0,0,1,1.85.19,5.76,5.76,0,0,1,2.61,4.52,1.82,1.82,0,0,1-.77,1.69l-3.36,1.93a3.69,3.69,0,1,1-3.69-6.4Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "360.971px 416.209px"
    },
    id: "elpbfhrqkb7ae",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,409.22a3.7,3.7,0,0,1,3.7,6.4L365,418.28a1.82,1.82,0,0,0,.77-1.69,5.76,5.76,0,0,0-2.61-4.52,1.84,1.84,0,0,0-1.85-.19Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "366.358px 413.542px"
    },
    id: "el5yyzzamk6ub",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elooxz8ekbyan"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.26,412.65a1.42,1.42,0,0,0-1.94-.52l-5.6,3.22a5.35,5.35,0,0,0,1.85,1.95l.23.12,4.94-2.84A1.42,1.42,0,0,0,370.26,412.65Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "366.583px 414.68px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M361.34,411.88a1.84,1.84,0,0,1,1.85.19,5.76,5.76,0,0,1,2.61,4.52,1.82,1.82,0,0,1-.77,1.69l-3.36,1.93a3.69,3.69,0,1,1-3.69-6.4Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "360.971px 416.209px"
    },
    id: "els1fsz72gwih",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elcrmfhed4b4n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.8,416.59a5.76,5.76,0,0,0-2.61-4.52,1.84,1.84,0,0,0-1.85-.19l.27-.15.2-.11a1.8,1.8,0,0,1,1.84.18,5.78,5.78,0,0,1,2.61,4.52,1.84,1.84,0,0,1-.76,1.69l-.47.27A1.82,1.82,0,0,0,365.8,416.59Z",
    style: {
      opacity: 0.1,
      transformOrigin: "363.805px 414.864px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M358.33,420.39h0a3.69,3.69,0,0,1-.35-6.58l3.36-1.93a1.84,1.84,0,0,1,1.85.19,4.47,4.47,0,0,1,.9.7L358.48,416C356.63,417.07,357.29,419.76,358.33,420.39Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "360.107px 416.052px"
    },
    id: "elihchkwb3psg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.84,419.21a1.41,1.41,0,0,1,.52-1.93L365,414a5.3,5.3,0,0,1,.77,2.58c0,.09,0,.17,0,.25l-5,2.89A1.42,1.42,0,0,1,358.84,419.21Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "362.21px 416.954px"
    },
    id: "ell4bg8nwubq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eltdvd2oz870n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.23,411a1.46,1.46,0,0,1,.07.19.88.88,0,0,1,.05.15c0,.05,0,.11,0,.16s0,.11,0,.17,0,.06,0,.09a3.25,3.25,0,0,1,.06.76v0a2.46,2.46,0,0,1,0,.28h0c0-1.21-2-3.13-3.87-2.06l-3.53,2a4.47,4.47,0,0,0-.9-.7,1.84,1.84,0,0,0-1.85-.19l4.63-2.66a3.69,3.69,0,0,1,5,1.35,3,3,0,0,1,.16.31A1.17,1.17,0,0,1,371.23,411Z",
    style: {
      opacity: 0.1,
      transformOrigin: "366.337px 410.756px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el04a4pnzon9ty"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334,434.12h0a4.9,4.9,0,0,0,.66.31,2.24,2.24,0,0,0,.26.1,7.87,7.87,0,0,0,6-.54l6.25-3.61.05,0a4.46,4.46,0,0,0,.17-7.82,5,5,0,0,0-.66-.31l-.26-.09a7.88,7.88,0,0,0-6,.53l-6.25,3.61,0,0a4.46,4.46,0,0,0-.18,7.82Z",
    style: {
      fill: "rgb(250, 250, 250)",
      mixBlendMode: "hard-light",
      opacity: 0.7,
      transformOrigin: "340.717px 428.344px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M347.43,426.39a7.66,7.66,0,0,0-6.91.13l-6.26,3.61c-2,1.14-2.06,2.92-.22,4A7.65,7.65,0,0,0,341,434l6.25-3.61C349.18,429.25,349.28,427.46,347.43,426.39Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "340.734px 430.267px"
    },
    id: "elwdgsu6326fd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.15,428.46a4.46,4.46,0,0,0-1.72-5.93,5,5,0,0,0-.66-.31l-.26-.09a8.06,8.06,0,0,0-5.22.16c2.93-.29,4.74-.38,6.57,1.17A4.51,4.51,0,0,1,349.15,428.46Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "345.474px 425.116px"
    },
    id: "eldvsr2mzi43g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,425.47a1.8,1.8,0,0,1,1.84.18,5.78,5.78,0,0,1,2.61,4.52,1.84,1.84,0,0,1-.76,1.69l-3.36,1.93a3.7,3.7,0,0,1-3.7-6.4Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "337.692px 429.752px"
    },
    id: "elsdngmyg562a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.66,422.8a3.69,3.69,0,1,1,3.69,6.4l-4.63,2.66a1.84,1.84,0,0,0,.76-1.69,5.78,5.78,0,0,0-2.61-4.52,1.8,1.8,0,0,0-1.84-.18Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "343.114px 427.083px"
    },
    id: "eltmz54hat60a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eltj3gbdlom8i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.94,426.23a1.41,1.41,0,0,0-1.93-.52l-5.6,3.22a5.33,5.33,0,0,0,1.84,1.95l.23.12,4.94-2.84A1.41,1.41,0,0,0,346.94,426.23Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "343.27px 428.26px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M338,425.47a1.8,1.8,0,0,1,1.84.18,5.78,5.78,0,0,1,2.61,4.52,1.84,1.84,0,0,1-.76,1.69l-3.36,1.93a3.7,3.7,0,0,1-3.7-6.4Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "337.692px 429.752px"
    },
    id: "eltmfkljo4jnn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljx7ivjvoirh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.48,430.17a5.78,5.78,0,0,0-2.61-4.52,1.8,1.8,0,0,0-1.84-.18l.26-.16.2-.11a1.86,1.86,0,0,1,1.85.18A5.78,5.78,0,0,1,343,429.9a1.83,1.83,0,0,1-.77,1.69l-.46.27A1.84,1.84,0,0,0,342.48,430.17Z",
    style: {
      opacity: 0.1,
      transformOrigin: "340.52px 428.447px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M335,434h0a3.64,3.64,0,0,1-1.7-1.53,3.69,3.69,0,0,1,1.35-5.05l3.37-1.92a1.8,1.8,0,0,1,1.84.18,4,4,0,0,1,.9.71c-2,1.12-4.36,2.5-5.61,3.23C333.32,430.65,334,433.35,335,434Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "336.781px 429.664px"
    },
    id: "elbbnpaq856ha",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.53,432.79a1.42,1.42,0,0,1,.51-1.93l5.68-3.27a5.39,5.39,0,0,1,.76,2.58,2.26,2.26,0,0,1,0,.26l-5,2.88A1.41,1.41,0,0,1,335.53,432.79Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "338.913px 430.549px"
    },
    id: "el4nnjv131d0w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqjezbhmzka"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.91,424.57c0,.06,0,.13.08.2a1.21,1.21,0,0,0,.05.14l0,.16a1,1,0,0,1,0,.17s0,.06,0,.09a4.9,4.9,0,0,1,.06.77v0c0,.09,0,.18,0,.27h0c0-1.21-2-3.12-3.87-2.06-.63.36-1.59.9-3.54,2a4,4,0,0,0-.9-.71,1.8,1.8,0,0,0-1.84-.18l4.63-2.67a3.7,3.7,0,0,1,5,1.35,1.77,1.77,0,0,1,.15.31A.37.37,0,0,1,347.91,424.57Z",
    style: {
      opacity: 0.1,
      transformOrigin: "343.025px 424.323px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elegn2tyn8i37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.09,430.2h0a4.9,4.9,0,0,0,.66.31l.26.1a7.87,7.87,0,0,0,6-.54l6.25-3.61.05,0a4.4,4.4,0,0,0,1.8-1.73,4.44,4.44,0,0,0-1.63-6.09,5,5,0,0,0-.66-.31l-.26-.09a7.88,7.88,0,0,0-6,.53l-6.25,3.61-.05,0a4.45,4.45,0,0,0-.18,7.82Z",
    style: {
      fill: "rgb(250, 250, 250)",
      mixBlendMode: "hard-light",
      opacity: 0.7,
      transformOrigin: "380.778px 424.424px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M387.48,422.47a7.65,7.65,0,0,0-6.92.13l-6.25,3.61c-2,1.14-2.07,2.92-.22,4a7.65,7.65,0,0,0,6.92-.13l6.25-3.61C389.23,425.33,389.33,423.54,387.48,422.47Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "380.78px 426.34px"
    },
    id: "el9ppmiaq8bj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.2,424.54a4.46,4.46,0,0,0-1.72-5.93,5,5,0,0,0-.66-.31l-.26-.09a8.06,8.06,0,0,0-5.22.16c2.93-.3,4.73-.38,6.57,1.16A4.53,4.53,0,0,1,389.2,424.54Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "385.524px 421.196px"
    },
    id: "el7jxaapiv13",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.07,421.55a1.81,1.81,0,0,1,1.85.18,5.78,5.78,0,0,1,2.61,4.52,1.84,1.84,0,0,1-.76,1.69l-3.36,1.93a3.7,3.7,0,0,1-3.7-6.4Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "377.772px 425.831px"
    },
    id: "elr10vrt8jya",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.71,418.88a3.69,3.69,0,1,1,3.69,6.4l-4.63,2.66a1.84,1.84,0,0,0,.76-1.69,5.78,5.78,0,0,0-2.61-4.52,1.81,1.81,0,0,0-1.85-.18Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "383.163px 423.161px"
    },
    id: "el40m9j8b1r6v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8ypkaid7a13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387,422.31a1.41,1.41,0,0,0-1.93-.52L379.45,425A5.44,5.44,0,0,0,381.3,427l.23.12,4.94-2.84A1.41,1.41,0,0,0,387,422.31Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "383.327px 424.36px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M378.07,421.55a1.81,1.81,0,0,1,1.85.18,5.78,5.78,0,0,1,2.61,4.52,1.84,1.84,0,0,1-.76,1.69l-3.36,1.93a3.7,3.7,0,0,1-3.7-6.4Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "377.772px 425.831px"
    },
    id: "elcb87yxx8irk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elc1m9hap5ayj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.53,426.25a5.78,5.78,0,0,0-2.61-4.52,1.81,1.81,0,0,0-1.85-.18l.27-.16.2-.11a1.8,1.8,0,0,1,1.84.18A5.76,5.76,0,0,1,383,426a1.84,1.84,0,0,1-.77,1.69l-.46.27A1.84,1.84,0,0,0,382.53,426.25Z",
    style: {
      opacity: 0.1,
      transformOrigin: "380.54px 424.534px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M375.06,430.05h0a3.64,3.64,0,0,1-1.7-1.53,3.69,3.69,0,0,1,1.35-5l3.36-1.92a1.81,1.81,0,0,1,1.85.18,4.2,4.2,0,0,1,.9.7l-5.61,3.24C373.37,426.73,374,429.42,375.06,430.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "376.851px 425.738px"
    },
    id: "el27mjlovk0k7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.58,428.87a1.41,1.41,0,0,1,.51-1.93l5.67-3.27a5.3,5.3,0,0,1,.77,2.58,2,2,0,0,1,0,.25l-5,2.89A1.41,1.41,0,0,1,375.58,428.87Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "378.961px 426.629px"
    },
    id: "elmrfkl1iw9kp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3xarhdf7tf4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388,420.65c0,.06.05.13.08.19s0,.1,0,.15a1,1,0,0,1,.05.16c0,.06,0,.11,0,.17s0,.06,0,.09a4.87,4.87,0,0,1,.06.76v0c0,.1,0,.19,0,.28h0c0-1.21-2-3.13-3.87-2.06l-3.54,2a4.2,4.2,0,0,0-.9-.7,1.81,1.81,0,0,0-1.85-.18l4.64-2.67a3.7,3.7,0,0,1,5.05,1.35l.15.31A1.17,1.17,0,0,1,388,420.65Z",
    style: {
      opacity: 0.1,
      transformOrigin: "383.11px 420.398px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elz710p9ay5v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.78,443.78h0a5.59,5.59,0,0,0,.65.32l.26.09a7.86,7.86,0,0,0,6-.54l6.25-3.61.05,0a4.45,4.45,0,0,0,.18-7.82,6.53,6.53,0,0,0-.66-.31l-.27-.09a7.88,7.88,0,0,0-6,.53L351,435.93l-.05,0a4.46,4.46,0,0,0-.17,7.82Z",
    style: {
      fill: "rgb(250, 250, 250)",
      mixBlendMode: "hard-light",
      opacity: 0.7,
      transformOrigin: "357.478px 438.004px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M364.16,436.05a7.66,7.66,0,0,0-6.91.13L351,439.79c-2,1.14-2.07,2.92-.22,4a7.63,7.63,0,0,0,6.91-.13l6.25-3.61C365.91,438.91,366,437.12,364.16,436.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "357.463px 439.922px"
    },
    id: "el2dnqlko9p4y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.88,438.12a4.46,4.46,0,0,0-1.71-5.93,6.53,6.53,0,0,0-.66-.31l-.27-.09A8.13,8.13,0,0,0,358,432c2.93-.29,4.74-.38,6.58,1.17A4.52,4.52,0,0,1,365.88,438.12Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "362.195px 434.787px"
    },
    id: "els36rx1dbk6i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.76,435.13a1.8,1.8,0,0,1,1.84.18,5.75,5.75,0,0,1,2.61,4.52,1.84,1.84,0,0,1-.76,1.69l-3.36,1.94a3.7,3.7,0,0,1-3.7-6.41Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "354.381px 439.456px"
    },
    id: "elf5128dn5c7n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.39,432.46a3.7,3.7,0,1,1,3.7,6.4l-4.64,2.66a1.84,1.84,0,0,0,.76-1.69,5.75,5.75,0,0,0-2.61-4.52,1.8,1.8,0,0,0-1.84-.18Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "359.922px 436.699px"
    },
    id: "el677qza7b6ui",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elzv6836kkakg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.67,435.89a1.41,1.41,0,0,0-1.93-.52l-5.6,3.22a5.27,5.27,0,0,0,1.85,2,2.39,2.39,0,0,0,.22.12l4.94-2.84A1.41,1.41,0,0,0,363.67,435.89Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "360.011px 437.945px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M354.76,435.13a1.8,1.8,0,0,1,1.84.18,5.75,5.75,0,0,1,2.61,4.52,1.84,1.84,0,0,1-.76,1.69l-3.36,1.94a3.7,3.7,0,0,1-3.7-6.41Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "354.381px 439.456px"
    },
    id: "el5gmwtk4qj3s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elw3v8m276k6a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.21,439.83a5.75,5.75,0,0,0-2.61-4.52,1.8,1.8,0,0,0-1.84-.18L355,435l.2-.11a1.86,1.86,0,0,1,1.85.18,5.78,5.78,0,0,1,2.61,4.52,1.81,1.81,0,0,1-.77,1.69l-.46.27A1.84,1.84,0,0,0,359.21,439.83Z",
    style: {
      opacity: 0.1,
      transformOrigin: "357.216px 438.137px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M351.74,443.63h0a3.7,3.7,0,0,1-.35-6.58l3.37-1.92a1.8,1.8,0,0,1,1.84.18,4,4,0,0,1,.9.71l-5.61,3.23C350.05,440.31,350.71,443,351.74,443.63Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "353.523px 439.294px"
    },
    id: "el3iea4maeo67",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.26,442.45a1.41,1.41,0,0,1,.52-1.93l5.67-3.27a5.39,5.39,0,0,1,.76,2.58,2.26,2.26,0,0,1,0,.26l-5,2.88A1.41,1.41,0,0,1,352.26,442.45Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "355.642px 440.209px"
    },
    id: "el42a904ula9z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el07pbgpz34ktn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.64,434.23a1.19,1.19,0,0,1,.08.2s0,.09,0,.14,0,.11,0,.16a1.36,1.36,0,0,1,0,.17s0,.06,0,.09a3.29,3.29,0,0,1,.06.77v0a2.45,2.45,0,0,1,0,.27h0c0-1.21-2-3.12-3.87-2.06-.63.37-1.59.9-3.54,2a4,4,0,0,0-.9-.71,1.8,1.8,0,0,0-1.84-.18l4.63-2.67a3.69,3.69,0,0,1,5.05,1.35,3,3,0,0,1,.16.31S364.63,434.19,364.64,434.23Z",
    style: {
      opacity: 0.1,
      transformOrigin: "359.707px 433.971px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eldj3230m5ur5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.82,439.86h0a4.29,4.29,0,0,0,.65.31l.26.1a7.87,7.87,0,0,0,6-.54l6.25-3.61.05,0a4.46,4.46,0,0,0,.17-7.82,5.51,5.51,0,0,0-.65-.31l-.27-.09a7.88,7.88,0,0,0-6,.53L391.05,432l-.05,0a4.46,4.46,0,0,0-.18,7.82Z",
    style: {
      fill: "rgb(250, 250, 250)",
      mixBlendMode: "hard-light",
      opacity: 0.7,
      transformOrigin: "397.512px 434.084px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M404.21,432.13a7.62,7.62,0,0,0-6.91.13l-6.25,3.61c-2,1.14-2.07,2.92-.23,4a7.65,7.65,0,0,0,6.92-.13l6.25-3.61C406,435,406.06,433.2,404.21,432.13Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "397.521px 435.999px"
    },
    id: "elaccfwduyo1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.93,434.2a4.45,4.45,0,0,0-1.72-5.93,5.51,5.51,0,0,0-.65-.31l-.27-.09a8.06,8.06,0,0,0-5.22.16c2.93-.29,4.74-.38,6.58,1.16A4.54,4.54,0,0,1,405.93,434.2Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "402.256px 430.856px"
    },
    id: "elmfnsiu30w79",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.81,431.21a1.8,1.8,0,0,1,1.84.18,5.78,5.78,0,0,1,2.61,4.52,1.84,1.84,0,0,1-.76,1.69l-3.36,1.93a3.7,3.7,0,1,1-3.7-6.4Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "394.358px 435.575px"
    },
    id: "el710yu5tf1br",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.44,428.54a3.7,3.7,0,0,1,3.7,6.4l-4.64,2.66a1.84,1.84,0,0,0,.76-1.69,5.78,5.78,0,0,0-2.61-4.52,1.8,1.8,0,0,0-1.84-.18Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "399.828px 432.861px"
    },
    id: "el9ll954cl5pd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elgr5wnwp7mo7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.72,432a1.41,1.41,0,0,0-1.93-.52l-5.6,3.22a5.33,5.33,0,0,0,1.84,1.95l.23.12,4.94-2.84A1.41,1.41,0,0,0,403.72,432Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "400.05px 434.03px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M394.81,431.21a1.8,1.8,0,0,1,1.84.18,5.78,5.78,0,0,1,2.61,4.52,1.84,1.84,0,0,1-.76,1.69l-3.36,1.93a3.7,3.7,0,1,1-3.7-6.4Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "394.358px 435.575px"
    },
    id: "el91aue41cncd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9xghlfw7q3c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.26,435.91a5.78,5.78,0,0,0-2.61-4.52,1.8,1.8,0,0,0-1.84-.18l.26-.16.2-.11a1.81,1.81,0,0,1,1.85.18,5.78,5.78,0,0,1,2.61,4.52,1.81,1.81,0,0,1-.77,1.69l-.46.27A1.84,1.84,0,0,0,399.26,435.91Z",
    style: {
      opacity: 0.1,
      transformOrigin: "397.276px 434.183px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M391.79,439.71h0a3.7,3.7,0,0,1-.35-6.58l3.37-1.92a1.8,1.8,0,0,1,1.84.18,4.2,4.2,0,0,1,.9.7l-5.61,3.24C390.1,436.39,390.76,439.08,391.79,439.71Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "393.573px 435.374px"
    },
    id: "eleu7kyhcty9v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.31,438.53a1.41,1.41,0,0,1,.52-1.93l5.67-3.27a5.39,5.39,0,0,1,.76,2.58,2,2,0,0,1,0,.25l-5,2.89A1.41,1.41,0,0,1,392.31,438.53Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "395.692px 436.289px"
    },
    id: "elg040lc5wt2j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3du2afywg96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.69,430.31a1.19,1.19,0,0,1,.08.2s0,.09.05.14,0,.11,0,.16a1,1,0,0,1,0,.17s0,.06,0,.09a3.25,3.25,0,0,1,.06.76v0a2.45,2.45,0,0,1,0,.27h0c0-1.21-2-3.13-3.87-2.06l-3.54,2a4.2,4.2,0,0,0-.9-.7,1.8,1.8,0,0,0-1.84-.18l4.63-2.67a3.69,3.69,0,0,1,5.05,1.35,1.77,1.77,0,0,1,.15.31A.37.37,0,0,1,404.69,430.31Z",
    style: {
      opacity: 0.1,
      transformOrigin: "399.807px 430.046px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eleczxitxujgc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.51,453.44h0a4,4,0,0,0,.66.32l.26.09a7.84,7.84,0,0,0,6-.54l6.25-3.61.05,0a4.45,4.45,0,0,0,.18-7.82,6.53,6.53,0,0,0-.66-.31l-.26-.09a7.91,7.91,0,0,0-6,.53l-6.25,3.61,0,0a4.36,4.36,0,0,0-1.81,1.73,4.44,4.44,0,0,0,1.63,6.09Z",
    style: {
      fill: "rgb(250, 250, 250)",
      mixBlendMode: "hard-light",
      opacity: 0.7,
      transformOrigin: "374.237px 447.666px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M380.89,445.71a7.66,7.66,0,0,0-6.91.13l-6.25,3.61c-2,1.14-2.07,2.92-.22,4a7.62,7.62,0,0,0,6.91-.13l6.25-3.61C382.64,448.57,382.74,446.78,380.89,445.71Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "374.195px 449.582px"
    },
    id: "elygium7wxm3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.62,447.78a4.46,4.46,0,0,0-1.72-5.93,6.53,6.53,0,0,0-.66-.31l-.26-.09a8.06,8.06,0,0,0-5.22.17c2.92-.3,4.73-.39,6.57,1.16A4.51,4.51,0,0,1,382.62,447.78Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "378.944px 444.438px"
    },
    id: "elzgk69rucaw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.49,444.79a1.81,1.81,0,0,1,1.85.18,5.78,5.78,0,0,1,2.61,4.52,1.82,1.82,0,0,1-.77,1.69l-3.36,1.94a3.7,3.7,0,0,1-3.7-6.41Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "371.116px 449.115px"
    },
    id: "elwco4f1yetpl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.12,442.12a3.7,3.7,0,1,1,3.7,6.4l-4.64,2.66a1.82,1.82,0,0,0,.77-1.69,5.78,5.78,0,0,0-2.61-4.52,1.81,1.81,0,0,0-1.85-.18Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "376.652px 446.359px"
    },
    id: "eljlvjpo0530d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpgrs1g5q0bb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.4,445.55a1.41,1.41,0,0,0-1.93-.52l-5.6,3.22a5.35,5.35,0,0,0,1.85,1.95,2.39,2.39,0,0,0,.22.12l4.95-2.84A1.41,1.41,0,0,0,380.4,445.55Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "376.731px 447.58px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M371.49,444.79a1.81,1.81,0,0,1,1.85.18,5.78,5.78,0,0,1,2.61,4.52,1.82,1.82,0,0,1-.77,1.69l-3.36,1.94a3.7,3.7,0,0,1-3.7-6.41Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "371.116px 449.115px"
    },
    id: "elkd0hsxb3vuh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el5wgek8cye85"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376,449.49a5.78,5.78,0,0,0-2.61-4.52,1.81,1.81,0,0,0-1.85-.18l.26-.16.2-.11a1.86,1.86,0,0,1,1.85.18,5.78,5.78,0,0,1,2.61,4.52,1.83,1.83,0,0,1-.76,1.69l-.47.27A1.82,1.82,0,0,0,376,449.49Z",
    style: {
      opacity: 0.1,
      transformOrigin: "374.005px 447.767px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M368.48,453.29h0a3.66,3.66,0,0,1-1.71-1.53,3.7,3.7,0,0,1,1.35-5.05l3.37-1.92a1.81,1.81,0,0,1,1.85.18,4.83,4.83,0,0,1,.9.71l-5.62,3.23C366.78,450,367.44,452.67,368.48,453.29Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "370.258px 448.953px"
    },
    id: "el2xigytov8nn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,452.12a1.42,1.42,0,0,1,.52-1.94l5.67-3.27a5.41,5.41,0,0,1,.77,2.58c0,.09,0,.17,0,.26l-5,2.88A1.42,1.42,0,0,1,369,452.12Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "372.385px 449.871px"
    },
    id: "eldijg28wdy2i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpzrtlsb2el9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.38,443.89c0,.07.05.13.07.2a.58.58,0,0,1,.05.14s0,.11.05.16,0,.12,0,.17,0,.06,0,.09a3.29,3.29,0,0,1,.06.77v0a2.45,2.45,0,0,1,0,.27h0c0-1.21-2-3.12-3.87-2.06-.63.37-1.59.9-3.53,2a4.83,4.83,0,0,0-.9-.71,1.81,1.81,0,0,0-1.85-.18l4.63-2.67a3.69,3.69,0,0,1,5.05,1.35c.06.1.11.21.16.31Z",
    style: {
      opacity: 0.1,
      transformOrigin: "376.537px 443.631px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottle--inject-114",
    className: "animable",
    style: {
      transformOrigin: "260.331px 338.269px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.15,303.66c0-5.59-3.69-11.18-11.07-15.44-14.78-8.53-38.73-8.53-53.5,0-7.38,4.26-11.08,9.85-11.08,15.44v87.79c0,5.59,3.7,11.18,11.08,15.45,14.77,8.53,38.72,8.53,53.5,0,7.38-4.27,11.08-9.86,11.07-15.45h0Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "260.325px 347.56px"
    },
    id: "elhp8bl5w2fz8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el86uullt5lav"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.61,286.47V408.65c1.2-.54,2.36-1.12,3.47-1.75a29,29,0,0,0,6-4.56V292.78a28.69,28.69,0,0,0-6-4.56A38.8,38.8,0,0,0,283.61,286.47Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "288.345px 347.56px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elvg9y76kyoyh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.7,411.87a55,55,0,0,0,5.44-1.49V284.74a50,50,0,0,0-5.44-1.49Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "276.42px 347.56px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el57d10tdd9k8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.5,299.63a27.28,27.28,0,0,0-8.8-7.65c-14.58-8.41-37.58-9-53.33-1.74v-2.95c-.6.3-1.21.6-1.79.93-7.38,4.26-11.08,9.85-11.08,15.44v87.79c0,5.59,3.7,11.18,11.08,15.45,14.77,8.53,38.72,8.53,53.5,0a28.12,28.12,0,0,0,6.74-5.28c-7,6.57-24.55,10.19-37.56,7.63s-20.89-10.86-20.89-16.76v-3.16c7.29,4,16.83,5.83,26.16,5.83V338.8c-9.33,0-18.87-1.44-26.16-5.36v-6.95c15.75,7.24,38.75,6.67,53.33-1.75a25.77,25.77,0,0,0,9.45-8.72V303.66A13.07,13.07,0,0,0,297.5,299.63Z",
    style: {
      opacity: 0.1,
      transformOrigin: "260.325px 349.249px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elmvju2rbfd8p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.89,394.16V291.52c-4.25,3.66-6.39,7.9-6.39,6.67V386c0,11.06,3.7,16.65,11.08,20.92A47.72,47.72,0,0,0,248,412.07C233.73,408.22,228.89,398.51,228.89,394.16Z",
    style: {
      opacity: 0.1,
      transformOrigin: "235.25px 351.795px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M300.45,286.39c0-5.93-3.92-11.86-11.75-16.38C273,261,247.63,261,232,270c-7.83,4.52-11.75,10.45-11.75,16.38h0v17.78h0c0,5.93,3.92,11.85,11.75,16.38,15.67,9,41.07,9,56.74,0,7.83-4.53,11.75-10.45,11.75-16.38h0V286.39Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "260.37px 295.271px"
    },
    id: "elqmjb5z1t9vq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbxog4s7ak9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.93,326.63c-19.85.11-30.33-6.33-33.51-11.6-2.42-4-2.84-11.38-2.84-18.7,0,0-2.24-16.68-1.8-16.73.27,0-4.76-1.12-8.62-1.94a15.05,15.05,0,0,0-2.95,8.73h0v17.78h0c0,5.93,3.92,11.85,11.75,16.38C242.26,326.49,256.75,328.5,269.93,326.63Z",
    style: {
      opacity: 0.1,
      transformOrigin: "245.07px 302.483px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elqv1wu496fp"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "260.31px 305.125px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.33,327.11c-.64,0-1.28-.05-1.92-.11V303.71h1.92Z",
    id: "el5a8tuj3agzv",
    className: "animable",
    style: {
      transformOrigin: "255.37px 315.41px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.27,323.82c-.66-.23-1.29-.48-1.93-.73V300.16h1.93Z",
    id: "el13lqeuwjuyy",
    className: "animable",
    style: {
      transformOrigin: "238.305px 311.99px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.52,326c-.63-.13-1.3-.19-1.92-.33V302.53h1.92Z",
    id: "el7omjkh1eur8",
    className: "animable",
    style: {
      transformOrigin: "246.56px 314.265px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.87,319.21V296.49h1.92v23.95C231.11,320,230.49,319.63,229.87,319.21Z",
    id: "elmtjmzouznfr",
    className: "animable",
    style: {
      transformOrigin: "230.83px 308.465px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.17,309.13a13.92,13.92,0,0,1-1-5h0V286.39h0a13.8,13.8,0,0,1,.45-3.3h.51Z",
    id: "el4xmfs3te3v5",
    className: "animable",
    style: {
      transformOrigin: "220.67px 296.11px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.92,313.85V291.37h1.93V316A23.57,23.57,0,0,1,223.92,313.85Z",
    id: "el20ed50tg2jgj",
    className: "animable",
    style: {
      transformOrigin: "224.885px 303.685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.36,327.05c-.64.05-1.28.08-1.93.11V303.75h1.93Z",
    id: "elassp6x23z39",
    className: "animable",
    style: {
      transformOrigin: "264.395px 315.455px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.65,323.4c-.62.24-1.29.41-1.92.63V300.54h1.92Z",
    id: "elmoirpkqgosd",
    className: "animable",
    style: {
      transformOrigin: "281.69px 312.285px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.25,325.84c-.63.13-1.29.21-1.93.33V302.68h1.93Z",
    id: "el4i77uqd4bk4",
    className: "animable",
    style: {
      transformOrigin: "273.285px 314.425px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.36,320.71V297.35h1.93v22.18c-.53.34-1,.69-1.59,1Z",
    id: "elyu3m8wga6nf",
    className: "animable",
    style: {
      transformOrigin: "289.325px 309.03px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.06,315.73V292.21H297v21.33A22.63,22.63,0,0,1,295.06,315.73Z",
    id: "elbfoi9r0f9l",
    className: "animable",
    style: {
      transformOrigin: "296.03px 303.97px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.48,284.74h.83a13.12,13.12,0,0,1,.14,1.65v17.78a13.93,13.93,0,0,1-1,5Z",
    id: "elg3tei0o7hg",
    className: "animable",
    style: {
      transformOrigin: "299.95px 296.955px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M232,302.76c15.67,9.05,41.07,9.05,56.74,0s15.67-23.71,0-32.75S247.63,261,232,270,216.29,293.72,232,302.76Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "260.37px 286.394px"
    },
    id: "elmp2j8jc0hr7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.85,301.39c13.45-9.1,12.75-22.78-2.15-31.38-7.64-4.41-17.59-6.66-27.6-6.77a44.76,44.76,0,0,0-14.64,5c-13.54,7.75-13.54,23.2,0,30.95C258.55,306.09,277.32,306.81,290.85,301.39Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "268.369px 284.107px"
    },
    id: "el5aanycecbln",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elmb45k2221w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.76,405.17c13.57,6.82,35.57,6.82,49.14,0s13.57-17.87,0-24.69-35.57-6.82-49.14,0S222.19,398.35,235.76,405.17Z",
    style: {
      opacity: 0.1,
      transformOrigin: "260.33px 392.825px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M222.5,318.84c0,5.59,3.7,11.18,11.08,15.44s17.07,6.4,26.75,6.4v55.89c-9.68,0-19.36-2.14-26.75-6.4s-11.08-9.85-11.08-15.44Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "241.415px 357.705px"
    },
    id: "elkjn8bmmrxzs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.58,352.23a45.3,45.3,0,0,0,11.16,4.43v-4.53a45.32,45.32,0,0,1-11.16-4.44c-7.38-4.26-11.08-9.85-11.08-15.44v4.53C222.5,342.37,226.2,348,233.58,352.23Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "233.62px 344.455px"
    },
    id: "el5waczwwcosv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.74,376.75a45.3,45.3,0,0,1-11.16-4.43c-7.38-4.27-11.08-9.86-11.08-15.45v4.54c0,5.59,3.7,11.18,11.08,15.44a44.92,44.92,0,0,0,11.16,4.43Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "233.62px 369.075px"
    },
    id: "el1mhtn3s9dr3i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.58,364.54A44.92,44.92,0,0,0,244.74,369v-4.53A45.7,45.7,0,0,1,233.58,360c-7.38-4.27-11.08-9.86-11.08-15.45v4.54C222.5,354.69,226.2,360.27,233.58,364.54Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "233.62px 356.775px"
    },
    id: "el985fzqxo2nj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.27,295.28s13.06,13.13,38.26,12.45,35.29-14.45,36.62-18.72.49-9.82-3.4-14.53a16.76,16.76,0,0,1,5.7,11.91v17.78c0,1.5.77,6.67-7.36,13.37,0,0,4.77-5.42,4.77-10.64V294.61s-8.92,14.93-36.33,14.93S224.66,297.52,223.27,295.28Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "261.87px 296.01px"
    },
    id: "el5l7vm2f3a7e",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pills--inject-114",
    className: "animable",
    style: {
      transformOrigin: "235.412px 440.987px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-114",
    d: "M221.78,434.8c6.35-3.66,16.65-3.66,23,0a9,9,0,0,1,4.53,5.14c6.07,3.68,6,9.5-.26,13.11s-16.65,3.66-23,0c-2.51-1.45-4-3.26-4.54-5.14C215.44,444.23,215.52,438.42,221.78,434.8Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "235.412px 443.916px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pill--inject-114",
    className: "animable",
    style: {
      transformOrigin: "238.302px 443.522px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225,441.35v4.35c0,2,1.3,3.93,3.9,5.43,5.19,3,13.61,3,18.8,0a9,9,0,0,0,2.92-2.54,5,5,0,0,0,1-2.89v-4.35a4.67,4.67,0,0,0-.14-1.1c0-.12-.07-.24-.11-.36a7.62,7.62,0,0,0-3.65-4c-4.87-2.82-12.6-3-17.82-.52v2.17l-1.88,1.1V436.5a8.14,8.14,0,0,0-2.12,2.1q-.18.28-.33.57a4.55,4.55,0,0,0-.3.72A4.35,4.35,0,0,0,225,441.35Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "238.31px 443.507px"
    },
    id: "el3gxfpl8i7wi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.1,434.06c4.62-.87,9.9-.25,13.57,1.87a7.62,7.62,0,0,1,3.65,4c0,.12.08.24.11.36a4.67,4.67,0,0,1,.14,1.1v4.35a5,5,0,0,1-1,2.89,9,9,0,0,1-2.92,2.54c-3.67,2.12-8.95,2.73-13.57,1.85Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "242.825px 443.544px"
    },
    id: "el4xkt6xverkn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.67,435.93c4.88,2.81,5.17,7.27.89,10.28l-18.71-10.8C235.08,432.94,242.79,433.11,247.67,435.93Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "240.707px 439.944px"
    },
    id: "elu1ml14peauc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.27,433.68v.88a18.26,18.26,0,0,1,9,2.13c2.15,1.24,3.37,2.84,3.45,4.5a5,5,0,0,1-2.18,4l-16.64-9.61a20.6,20.6,0,0,1,6.41-1v-.88m0,0a20.13,20.13,0,0,0-8.42,1.73l18.71,10.8c4.28-3,4-7.47-.89-10.28a19.22,19.22,0,0,0-9.4-2.25Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "240.749px 439.955px"
    },
    id: "elj6r2e29373e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.57,445.07s5.17-4-.58-8.95c4.56,2.82,4.76,7.15.57,10.09l-18.71-10.8Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "240.706px 440.81px"
    },
    id: "el15nyyytt22i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,436.5l18.71,10.8c-5.22,2.47-12.94,2.3-17.82-.52S223.69,439.51,228,436.5Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "235.847px 442.766px"
    },
    id: "elc31s39zxvdt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,437.55l16.64,9.61a20.54,20.54,0,0,1-6.4,1,18.24,18.24,0,0,1-9-2.13c-2.15-1.24-3.38-2.84-3.46-4.5a5,5,0,0,1,2.18-4M228,436.5c-4.28,3-4,7.47.89,10.28a19.23,19.23,0,0,0,9.41,2.25,20.11,20.11,0,0,0,8.41-1.73L228,436.5Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "235.851px 442.767px"
    },
    id: "ellztodt1rz6p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.68,447.3c-5.22,2.47-12.94,2.3-17.82-.52a11.54,11.54,0,0,1-1.54-1.06c9.57,4.79,17.27,1.41,17.27,1.41L228,436.5Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "237px 442.766px"
    },
    id: "elox3y0w7ot9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.85 437.58 248.57 448.44 248.56 446.21 229.85 435.41 229.85 437.58",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "239.21px 441.925px"
    },
    id: "eltchfhopv45l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwl9c3afaoq"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "246.68 447.3 246.68 449.52 248.57 448.44 246.68 447.3",
    style: {
      opacity: 0.2,
      transformOrigin: "247.625px 448.41px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pill--inject-114",
    className: "animable",
    style: {
      transformOrigin: "231.135px 436.087px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.83,433.92v4.35c0,2,1.3,3.92,3.9,5.42,5.19,3,13.61,3,18.81,0a9,9,0,0,0,2.92-2.53,5,5,0,0,0,1-2.89v-4.35a4.54,4.54,0,0,0-.14-1.1,3,3,0,0,0-.11-.37,7.63,7.63,0,0,0-3.64-4c-4.88-2.81-12.6-3-17.82-.52v2.18l-1.88,1.09v-2.18a8,8,0,0,0-2.12,2.11,4.65,4.65,0,0,0-.34.56,5.5,5.5,0,0,0-.3.72A4.68,4.68,0,0,0,217.83,433.92Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "231.145px 436.069px"
    },
    id: "el0bxgvnu3h5m8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,426.63c4.62-.88,9.91-.26,13.58,1.86a7.63,7.63,0,0,1,3.64,4,3,3,0,0,1,.11.37,4.54,4.54,0,0,1,.14,1.1v4.35a5,5,0,0,1-1,2.89,9,9,0,0,1-2.92,2.53c-3.68,2.12-9,2.74-13.58,1.86Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "235.72px 436.11px"
    },
    id: "elk1q4umuhpn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.54,428.49c4.87,2.82,5.17,7.27.89,10.29L222.72,428C227.94,425.51,235.66,425.68,240.54,428.49Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "233.575px 432.515px"
    },
    id: "el4udzufsk6cg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.13,427.13h0a18.13,18.13,0,0,1,9,2.13c2.15,1.24,3.38,2.84,3.45,4.5a4.92,4.92,0,0,1-2.17,4l-16.64-9.61a20.25,20.25,0,0,1,6.4-1m0-.89a20,20,0,0,0-8.41,1.74l18.71,10.8c4.28-3,4-7.47-.89-10.29a19.23,19.23,0,0,0-9.41-2.25Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "233.619px 432.528px"
    },
    id: "ely3flg4gebpl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.43,437.64s5.17-4-.58-8.95c4.57,2.82,4.76,7.14.58,10.09L222.72,428Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "233.574px 433.39px"
    },
    id: "el74rew4w87om",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.84,429.06l18.71,10.81c-5.23,2.47-13,2.3-17.82-.52S216.56,432.08,220.84,429.06Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "228.703px 435.331px"
    },
    id: "elg7n82jw6qff",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.9,430.12l16.64,9.6a20.36,20.36,0,0,1-6.41,1,18.26,18.26,0,0,1-9-2.13c-2.15-1.24-3.38-2.84-3.45-4.51a5,5,0,0,1,2.18-4m-.06-1.06c-4.28,3-4,7.47.89,10.29a19.22,19.22,0,0,0,9.4,2.25,20.13,20.13,0,0,0,8.42-1.73l-18.71-10.81Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "228.651px 435.292px"
    },
    id: "el6v9nizd8ieg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.55,439.87c-5.23,2.47-13,2.3-17.82-.52a10.18,10.18,0,0,1-1.54-1.07c9.57,4.8,17.26,1.42,17.26,1.42l-16.61-10.64Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "229.87px 435.331px"
    },
    id: "eljppq67afzu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.72 430.15 241.43 441.01 241.43 438.78 222.72 427.98 222.72 430.15",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "232.075px 434.495px"
    },
    id: "elcotwxycbqng",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el4b2etm3grea"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "239.55 439.87 239.55 442.09 241.43 441.01 239.55 439.87",
    style: {
      opacity: 0.2,
      transformOrigin: "240.49px 440.98px"
    },
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pill--inject-114",
    className: "animable",
    style: {
      transformOrigin: "288.395px 450.463px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-114",
    d: "M277.62,446.64c-5.95,3.44-5.95,9,0,12.44s15.6,3.44,21.55,0,5.95-9,0-12.44S283.57,443.2,277.62,446.64Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "288.395px 452.86px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pill--inject-114",
    className: "animable",
    style: {
      transformOrigin: "288.386px 449.143px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.09,447v4.35c0,2,1.3,3.92,3.9,5.42,5.19,3,13.61,3,18.81,0a9,9,0,0,0,2.92-2.53,5,5,0,0,0,1-2.89V447a4.61,4.61,0,0,0-.14-1.1c0-.12-.06-.24-.1-.37a7.7,7.7,0,0,0-3.65-4c-4.88-2.81-12.6-3-17.82-.51v2.17l-1.88,1.09v-2.18A8,8,0,0,0,276,444.2a5.7,5.7,0,0,0-.34.57,4.87,4.87,0,0,0-.3.71A4.68,4.68,0,0,0,275.09,447Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "288.405px 449.149px"
    },
    id: "elhmyw74hfpj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.22,439.66c4.62-.88,9.91-.25,13.58,1.86a7.7,7.7,0,0,1,3.65,4c0,.13.07.25.1.37a4.61,4.61,0,0,1,.14,1.1v4.35a5,5,0,0,1-1,2.89,9,9,0,0,1-2.92,2.53c-3.68,2.13-9,2.74-13.58,1.86Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "292.94px 449.142px"
    },
    id: "elakj59kxlqn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.8,441.52c4.87,2.82,5.17,7.28.89,10.29L280,441C285.2,438.54,292.92,438.71,297.8,441.52Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "290.845px 445.543px"
    },
    id: "elx55amoxnp6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.4,440.16h0a18.18,18.18,0,0,1,9,2.13c2.15,1.24,3.37,2.84,3.45,4.5a5,5,0,0,1-2.18,4L282,441.15a20.56,20.56,0,0,1,6.41-1m0-.88A20,20,0,0,0,280,441l18.71,10.8c4.28-3,4-7.47-.89-10.29a19.34,19.34,0,0,0-9.41-2.24Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "290.859px 445.533px"
    },
    id: "eld0pbwwzmbjm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.69,450.67s5.17-4-.57-8.95c4.56,2.82,4.75,7.14.57,10.09L280,441Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "290.844px 446.405px"
    },
    id: "elnp30lnnzxj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.1,442.09l18.71,10.81c-5.23,2.47-12.94,2.3-17.82-.52S273.82,445.11,278.1,442.09Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "285.953px 448.361px"
    },
    id: "elm02somglpto",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.16,443.15l16.64,9.6a20.31,20.31,0,0,1-6.41,1,18.26,18.26,0,0,1-9-2.13c-2.15-1.24-3.37-2.84-3.45-4.51a5,5,0,0,1,2.18-4m-.06-1.06c-4.28,3-4,7.48.89,10.29a19.22,19.22,0,0,0,9.4,2.25,20.13,20.13,0,0,0,8.42-1.73L278.1,442.09Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "285.911px 448.322px"
    },
    id: "el59cqeb1a09b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.81,452.9c-5.23,2.47-12.94,2.3-17.82-.52a10.93,10.93,0,0,1-1.54-1.06c9.57,4.79,17.27,1.41,17.27,1.41L278.1,442.09Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "287.13px 448.361px"
    },
    id: "elo34apgq27mq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.98 443.18 298.69 454.04 298.69 451.81 279.98 441.01 279.98 443.18",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "289.335px 447.525px"
    },
    id: "elo2gqrk6ahit",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elxuzy16dkq9"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "296.81 452.9 296.81 455.12 298.69 454.04 296.81 452.9",
    style: {
      opacity: 0.2,
      transformOrigin: "297.75px 454.01px"
    },
    className: "animable"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-114",
    className: "animable",
    style: {
      transformOrigin: "139.768px 248.799px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-114",
    className: "animable",
    style: {
      transformOrigin: "139.768px 248.799px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.55,118.36c11,2.22,15,5.41,21.17,15.72,4.56,7.62,7.32,12.56,14.75,23.3l23.23,2.52L193,176.68s-14.31.45-22.41,1.09c-6.06.48-7.45,0-11.22-4.54-7.8-9.37-17.17-22.71-17.17-22.71Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "168.125px 148.139px"
    },
    id: "el8osypqsaj7p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3jjbe0x6cop"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.55,118.36c11,2.22,15,5.41,21.17,15.72,4.56,7.62,7.32,12.56,14.75,23.3l23.23,2.52L193,176.68s-14.31.45-22.41,1.09c-6.06.48-7.45,0-11.22-4.54-7.8-9.37-17.17-22.71-17.17-22.71Z",
    style: {
      opacity: 0.02,
      transformOrigin: "168.125px 148.139px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160.42,187.52l3.18,93s-28.48-7-54-2.69S78,288.14,78,288.14L94.46,144.27l58.89,1.78S160.42,155.71,160.42,187.52Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "120.8px 216.205px"
    },
    id: "el5f4m85gkw23",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-114",
    className: "animable",
    style: {
      transformOrigin: "120.636px 320.994px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.13,434.33c-.27,5.91-1.31,8.95-3.9,12.14A11.94,11.94,0,0,1,67.14,450c-4.57-1.23-9.33-4.65-10.39-9.61s-.07-9.77,1-13.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "69.7131px 438.609px"
    },
    id: "el5sld4hhlpzh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8,338.08c3.31-16.05,7-23.23,7.69-26.88,0,0,4.86-37.91,7.06-70.17,1.06-15.53.68-26,10.83-44l59,14.5c.72,8.27,6.27,64.56,3.54,113.1-2.24,39.84-5.16,52.84-5.46,59.49-.17,3.78-.09,6.28.07,11.53.07,2.12.25,3.86,1.48,5.2a36.7,36.7,0,0,0,6.69,5.3c4.59,3,6.7,4.67,11.95,6.54a12.38,12.38,0,0,1,2.92,1.3,3.27,3.27,0,0,1,1.57,2.54c0,1.42-1.3,2.54-2.62,3.24-4.75,2.52-10.69,2-15.88.5s-10-4-15.25-5.51c-3.62-1-7.45-1.51-10.77-3.2a5.38,5.38,0,0,1-2.59-2.31,5.5,5.5,0,0,1-.25-2.82c.4-4.16.84-5.47.73-9.66-.1-4-.71-11.33-1-15.31-.27-3.35-4.52-27.35-3.88-42.19a92.22,92.22,0,0,0-.47-13.6l-5.25-52.73c-2.4,8.81-11.29,34.33-14.06,46-3.4,14.24-5.23,31.47-12.3,57.54-2,7.34-5.68,16.19-6.59,20.63-.39,5.63-2.46,20.38-5.17,26.59-4.11,9.42-16.68,9.12-17.74.94-.89-6.95,3.79-25.14,4-29.7S64,356.78,67.8,338.08Z",
    style: {
      fill: "rgb(200, 133, 106)",
      transformOrigin: "118.539px 313.901px"
    },
    id: "ely9t3aeu141h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.15,400.23c-1,5.87-1.88,10.32-2.55,13.72-1.9,5.8-2.64,8.6-3.71,12.37-1.76,6.16-1.42,11.68.47,15,2.81,4.91,14.16,10,20.13,3.66,4.88-5.15,4.68-7.61,4.67-15.26,0-2.4,0-4.57,0-6.62.15-6.84.27-8.17,1.39-12.51.64-2.48,0-6.26.56-8.89.56-2.86.8-4.11-.17-4.56,0,0-.5,3.66-1.12,6.31-.57,2.43-1,4.88-1.57,7.31-.66,3-1.22,6-2.15,8.95-.1.32-.27.71-.63.75s-.72-.46-.74-.87a1.78,1.78,0,0,0-.47-1.35,6,6,0,0,0-1.62-.91,16.36,16.36,0,0,0-3.59-.87,17,17,0,0,0-5.32-.21,3.12,3.12,0,0,0-1.45.57c-.38.3-.51.72-.84,1a.79.79,0,0,1-1,.16.83.83,0,0,1-.23-.51,9.64,9.64,0,0,1-.06-2.08c.15-3.83.43-7.59,1-11.4a51.27,51.27,0,0,0,.91-9.07A11.13,11.13,0,0,0,64.15,400.23Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "71.1693px 421.43px"
    },
    id: "elxs2vt8l7icl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.42,410.42l60.19,12.1a4,4,0,0,1-.47,3.88c-2.2,2.57-9.61,6-18.77,5s-14.15-4.76-17.53-7.11a25.56,25.56,0,0,0-5.67-3.19c-2.18-.9-5.39-.94-7.71-1.24a44.06,44.06,0,0,1-6.07-1.59,13,13,0,0,1-4-2,13.91,13.91,0,0,1-.27-3.16C124.15,412.32,124.28,411.19,124.42,410.42Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "154.512px 420.999px"
    },
    id: "eliownwvz160k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.27,405c-1.88-2-4.4-3.09-6.94-4.17-2.15-.93-2.74-1.78-2.81-4.07,0-.2-1.75-.07-2,.2a2.77,2.77,0,0,0-.75,2c-.15,1.72-.37,2.52-.67,4.3-.67,3.95-1.63,5.2-1,9.84,2.69,3.31,11,4.89,15.47,5.44,7,.86,12.59,6.48,17.84,8.16,9.64,3.08,19.09,1.43,22.75-.35,4.24-2.06,6.62-5.45,3.14-7.91-2.13-1.5-14.2-7.48-16.37-8.61-1.72-.91-3.36-2-5-2.94a3,3,0,0,0-.9-.39,2.86,2.86,0,0,0-1.16.12,33.84,33.84,0,0,0-6.17,2.05,2.76,2.76,0,0,0-1.63,1.4c-.37,1.18,2.08,3.26.6,3.64-1.33.35-3.61-1.32-4.66-1.86-3.46-1.79-7-3.81-9.54-6.69A.86.86,0,0,0,138.27,405Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "154.435px 412.542px"
    },
    id: "elm6prhjqs9w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.28,194.11l.62,6c5.69,33.17,6.22,77.13,5.61,90.49-1.78,39.38-6.86,108.83-6.86,108.83s-1.57,3.86-12.77,4.75c-8.62.69-13.63-2.24-13.63-2.24s-4-47.08-4.63-58.45a112.66,112.66,0,0,1,.31-14.59,94.49,94.49,0,0,0-.22-18.19l-3-33.63s-11.16,46.58-12.24,52.25C100.08,357.77,87,410.49,87,410.49s-9.11,2.4-17.31.95-10.05-4.34-10.05-4.34,5.07-59.29,6.35-70.78c1.72-15.36,3.31-22.51,4.47-28.8,1.37-7.4,2-35.3,3-51.53.64-11.07,1.08-19.48,2.43-27.61,2.8-17,11.06-27.22,14.19-33.48l.49-3.35C99.83,199,134.94,203.6,152.28,194.11Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "109.174px 301.728px"
    },
    id: "eli71b7csyl1b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.7,277.09l8.74-31.74s11.35-2.17,16.93-8.31c0,0-1.26,7.75-13,11.71l-8.26,27.73-1.55,32.6Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "130.535px 273.06px"
    },
    id: "elqgd6fc7sf4",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-114",
    className: "animable",
    style: {
      transformOrigin: "142.38px 167.936px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Hair--inject-114",
    d: "M96.3,61.66c-.23-10.25,19.73-21.46,38.46-9s11.93,24.49,10.63,28.15l1.27,49L83.21,131.3s3-44.17,2.83-51.38S86.36,61.89,96.3,61.66Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "115.434px 89.2307px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-114",
    className: "animable",
    style: {
      transformOrigin: "118.687px 166.755px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.53,115.43l-15.39,4.1c-3.07,1,.39,19.13-.47,39.83C87.8,180.61,81.76,215,81.76,215s14.41,6,40.25,5.59c25.51-.42,33.13-8.38,33.13-8.38l-3.43-25.1L150,167.36s9.17-12.84,4.07-25.46-22.71-29-22.71-29l-7.91.39Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "118.687px 166.755px"
    },
    id: "elf7lubdc87rf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ellisb6n4tgp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.53,115.43l-15.39,4.1c-3.07,1,.39,19.13-.47,39.83C87.8,180.61,81.76,215,81.76,215s14.41,6,40.25,5.59c25.51-.42,33.13-8.38,33.13-8.38l-3.43-25.1L150,167.36s9.17-12.84,4.07-25.46-22.71-29-22.71-29l-7.91.39Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "118.687px 166.755px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eltsfgtxdyw49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103,165.82a17.13,17.13,0,0,0,15.09,7.43A17,17,0,0,0,131.64,165s-1.77,10.65-14.54,10.89S103,165.82,103,165.82Z",
    style: {
      fill: "rgb(255, 193, 0)",
      opacity: 0.3,
      transformOrigin: "117.32px 170.447px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M122.83,113.91c6.36,5.31,16.26,12.45,22.13,20.12,11.86,15.52,14.44,29.8,15.38,47.84.19-27,3.49-42.15-29-70-5.8-5-8.1-6.08-8.1-6.08Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "141.674px 143.83px"
    },
    id: "elmwiosyde3c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.44,110.35c.47,6.67,7.5,23.38,8.15,41.58s-9.41,136.42-9.41,136.42-19.27,2.44-33.46-5.64c0,0,5-42.89,16-90.55,2.83-12.36-2.34-27.69-3.38-44.35a70.31,70.31,0,0,1,3.47-26.74s10.32-3.45,13.47-5.28A16.62,16.62,0,0,0,101.44,110.35Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "88.1701px 199.523px"
    },
    id: "elpyrt52sono",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.67,113.58c.45,2.15,1.17,4.75,2,7.76,2.21,8.07,5.25,19.11,5.66,30.64.6,17-8.32,123.48-9.31,135.22-1.14.1-3.16.24-5.73.24-7,0-16.91-1-25.22-5.43.77-6.23,5.89-46.15,15.84-89.57,1.85-8.08.39-17.35-1.16-27.16-.89-5.66-1.82-11.51-2.19-17.54a70.72,70.72,0,0,1,3.2-25.67c2.26-.77,10.3-3.55,13.12-5.19a15.06,15.06,0,0,0,3.79-3.3m.77-3.23a16.62,16.62,0,0,1-5.2,5.44c-3.15,1.83-13.47,5.28-13.47,5.28a70.31,70.31,0,0,0-3.47,26.74c1,16.66,6.21,32,3.38,44.35-10.92,47.66-16,90.55-16,90.55,8.85,5,19.67,6,26.57,6a59.9,59.9,0,0,0,6.89-.35s10-118.21,9.41-136.42-7.68-34.91-8.15-41.58Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "88.1275px 199.531px"
    },
    id: "elexrzz0n103h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.37,64.83c1.88,1.41,4.36,5.81,4,13.22-.19,2.24,1.25,4.58,1.34,8.76.36,15.81-2.4,18.66-6.64,20.62a22.41,22.41,0,0,1-9.55,2l.5,7.64c2.72,4.49,2.63,7,2.18,12.81-14.16-4.06-25.14-13.76-25.15-13.79l-.53-17.84s-1.34-.37-1.34-.36a5.65,5.65,0,0,1-7,0c-3.22-2.36-5.41-8.29-2.65-11.69s7.81-2.09,9.66.83,6.26,2,4.83-2.47c2-1,4.48-3.11,2.45-11.33-.46-2.11.23-5.77,2.2-7.59,3.28-3,9.8-2.51,13.56,1.11C128.27,62.51,131.48,61.92,135.37,64.83Z",
    style: {
      fill: "rgb(200, 133, 106)",
      transformOrigin: "115.007px 96.453px"
    },
    id: "el83dfw4ixjoc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,73.55l-5.2-1a2.54,2.54,0,0,1,3-2.14A2.79,2.79,0,0,1,135,73.55Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "132.415px 71.9567px"
    },
    id: "eldzskg3bvh28",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.71,76l5-1.87a2.54,2.54,0,0,0-3.33-1.59A2.77,2.77,0,0,0,111.71,76Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "114.141px 74.1852px"
    },
    id: "el7zlanon4ia",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.51,93.92l7.4,2.3a3.71,3.71,0,0,1-4.72,2.62A4.08,4.08,0,0,1,118.51,93.92Z",
    style: {
      fill: "rgb(175, 97, 82)",
      transformOrigin: "122.142px 96.4673px"
    },
    id: "elfe64367pr5o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.89,99a3.46,3.46,0,0,0-3.58-3.31,2.83,2.83,0,0,0-.83.14,4,4,0,0,0,2.71,3.06A3.66,3.66,0,0,0,122.89,99Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "120.685px 97.3704px"
    },
    id: "eleod5dhto7c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.12 77.62 124.63 91.69 131.6 89.57 123.12 77.62",
    style: {
      fill: "rgb(175, 97, 82)",
      transformOrigin: "127.36px 84.655px"
    },
    id: "elytl6lfni8a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.57,109.4c-5.08-.17-16.54-2.93-19.33-9.61,0,0,.5,4.8,6.81,8.38,5,2.83,12.67,3.44,12.67,3.44Z",
    style: {
      fill: "rgb(175, 97, 82)",
      transformOrigin: "114.98px 105.7px"
    },
    id: "el5p7ahro9ipt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.88,81.24a2.24,2.24,0,1,1-2.12-2.37A2.25,2.25,0,0,1,118.88,81.24Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "116.644px 81.107px"
    },
    id: "elnh8bzsbdydc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.49,80.19a2.25,2.25,0,1,1-1.78-2.63A2.24,2.24,0,0,1,135.49,80.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "133.281px 79.7685px"
    },
    id: "eln66iz9xzp1m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,117.66c2.54-1.13,5.42-4.31,6.91-6.08s2-3,3-3l0,3.19s8.08,18.33,8,34.38h0c.18,11-1,23.93-1,23.93-3.31-7.78-11-20.58-11-20.58l4.2-10.07C99.59,129.47,93.84,123,92,117.66Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "100.964px 139.33px"
    },
    id: "elcrkxupmemv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pen--inject-114",
    className: "animable",
    style: {
      transformOrigin: "123.704px 185.126px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.4,172.75a.86.86,0,1,0-.86,1.5h0l.75.43a.4.4,0,0,0,.43,0,1.35,1.35,0,0,0,.61-1.06.45.45,0,0,0-.18-.4l-.75-.43Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "103.218px 173.689px"
    },
    id: "el4hb05tbor6o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.33,173.58a.45.45,0,0,0-.18-.4l-.75-.43h0a.84.84,0,0,0-.84,0h0c.23-.09.59.12,1,.36s.62.55.29,1.18c-.24.46-.52.41-.65.35l.08.05a.4.4,0,0,0,.43,0A1.35,1.35,0,0,0,104.33,173.58Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "103.446px 173.695px"
    },
    id: "elyu70fjhax29",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,172.7a2.69,2.69,0,1,0-2.69,4.65h0a1.33,1.33,0,0,0,1.34-.14,4.17,4.17,0,0,0,1.9-3.28,1.34,1.34,0,0,0-.55-1.23Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "105.198px 174.866px"
    },
    id: "eleoqbk7jpklv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.61,172.83a4.19,4.19,0,0,0-1.9,3.29,1.35,1.35,0,0,0,.55,1.23l16.59,9.58a1.33,1.33,0,0,0,1.34-.13,4.19,4.19,0,0,0,1.9-3.29,1.35,1.35,0,0,0-.55-1.23L107,172.7A1.33,1.33,0,0,0,105.61,172.83Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "113.9px 179.808px"
    },
    id: "elxygg0ls1rh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el05cj75bepbg3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.61,172.83a4.19,4.19,0,0,0-1.9,3.29,1.35,1.35,0,0,0,.55,1.23l16.59,9.58a1.33,1.33,0,0,0,1.34-.13,4.19,4.19,0,0,0,1.9-3.29,1.35,1.35,0,0,0-.55-1.23L107,172.7A1.33,1.33,0,0,0,105.61,172.83Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "113.9px 179.808px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M125.13,184.05a4.29,4.29,0,0,1-1.95,3.38,1.39,1.39,0,0,1-1.38.14l-1.28-.74a1.37,1.37,0,0,1-.57-1.26,4.32,4.32,0,0,1,2-3.38,1.39,1.39,0,0,1,1.38-.14l1.28.74A1.37,1.37,0,0,1,125.13,184.05Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "122.542px 184.81px"
    },
    id: "elh5pktzsei0c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elujz3e32dsu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.13,184.05a4.29,4.29,0,0,1-1.95,3.38,1.39,1.39,0,0,1-1.38.14l-1.28-.74a1.37,1.37,0,0,1-.57-1.26,4.32,4.32,0,0,1,2-3.38,1.39,1.39,0,0,1,1.38-.14l1.28.74A1.37,1.37,0,0,1,125.13,184.05Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.35,
      transformOrigin: "122.542px 184.81px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M121.23,186.3a4.32,4.32,0,0,1,2-3.38,1.19,1.19,0,0,1,1.95,1.13,4.29,4.29,0,0,1-1.95,3.38,1.39,1.39,0,0,1-1.38.14A1.37,1.37,0,0,1,121.23,186.3Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "123.214px 185.159px"
    },
    id: "elvj85ug983k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elezbazv5u5o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.23,186.3a4.32,4.32,0,0,1,2-3.38,1.19,1.19,0,0,1,1.95,1.13,4.29,4.29,0,0,1-1.95,3.38,1.39,1.39,0,0,1-1.38.14A1.37,1.37,0,0,1,121.23,186.3Z",
    style: {
      opacity: 0.15,
      transformOrigin: "123.214px 185.159px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M137.24,196.06a1.17,1.17,0,0,1-.5-1.09,3.75,3.75,0,0,1,1.69-2.93,1.21,1.21,0,0,1,1.2-.12h0l.62.6h0a1.22,1.22,0,0,1,.32.91,3.46,3.46,0,0,1-1.56,2.7,1.21,1.21,0,0,1-.94.17h0Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "138.653px 194.072px"
    },
    id: "el6bhh1v4ctfb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3pmpsy7na2j"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "138.653px 194.072px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.24,196.06a1.17,1.17,0,0,1-.5-1.09,3.75,3.75,0,0,1,1.69-2.93,1.21,1.21,0,0,1,1.2-.12h0l.62.6h0a1.22,1.22,0,0,1,.32.91,3.46,3.46,0,0,1-1.56,2.7,1.21,1.21,0,0,1-.94.17h0Z",
    id: "elmp3xwsgna4a",
    className: "animable",
    style: {
      transformOrigin: "138.653px 194.072px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M136.74,195a3.75,3.75,0,0,1,1.69-2.93,1.21,1.21,0,0,1,1.2-.12l-15-8.64a1.18,1.18,0,0,0-1.2.11,3.75,3.75,0,0,0-1.69,2.93,1.21,1.21,0,0,0,.49,1.1l15,8.64h0A1.17,1.17,0,0,1,136.74,195Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "130.682px 189.643px"
    },
    id: "elphg1v8p4pnc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.31,192.6a1.05,1.05,0,0,0-1.08.1,3.35,3.35,0,0,0-1.51,2.63,1.06,1.06,0,0,0,.44,1h0c1,.55,3.85,1.6,5.27,1.43v0a.51.51,0,0,0,.22-.07,1.25,1.25,0,0,0,.56-1,.46.46,0,0,0,0-.21h0C143.63,195.13,141.25,193.15,140.31,192.6Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "140.967px 195.137px"
    },
    id: "eldqty79sd8ig",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el6x43460fano"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.47,183.39a2.74,2.74,0,0,0-.48.36l15,8.65a3.75,3.75,0,0,1,.48-.36l.09,0-15-8.64Zm-1-1.44-.15,0-14.76-8.53c-1.93-1.12-2.73-1.09-3.51-.64.77-.28,2.53.75,2.76.88l14.89,8.6.18-.11,1.28.73a2.49,2.49,0,0,1,.59-.23Zm21.64,15.15-.23-.46s0-.35-.92-1.34a15.77,15.77,0,0,0-3.75-2.6,2.47,2.47,0,0,0-.55.44,21.46,21.46,0,0,1,4,2.59,8.66,8.66,0,0,1,1.36,1.45S144.12,197.13,144.13,197.1Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "124.09px 184.834px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.49,197.36l.62.36c.27.15,1,.4,1.15.18s-.47-.75-.74-.91h0l-.62-.35s-.15,0-.32.29S143.49,197.36,143.49,197.36Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "144.377px 197.313px"
    },
    id: "elrb5gey261sp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.2,197.63a.29.29,0,0,0-.18.13.31.31,0,0,0,0,.23c.13,0,.23,0,.27-.09S145.27,197.74,145.2,197.63Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "145.15px 197.81px"
    },
    id: "elvtxduj5ovpr",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.48,191.51c-.33-6.09,1-23.15,2.37-39.16,1.9-22,5.9-25.12,17.31-29.44,9.44,5.13,11.26,14.94,7.74,37l-3,25.66c6.13,1.3,14.46,3,21.49,1a10.21,10.21,0,0,0,3.89-2.1,7.23,7.23,0,0,1,2.27-1.19l1.51.89c1,.09,2.07.25,3.06.29,2.28.09,5.48,0,7.77.13,5,.3,8.75.6,13.31,2.59.86.38,1.94,1.05,3,1.67.82.46,0,1.39-.51,1.71a5.62,5.62,0,0,1-2.1.78,11.62,11.62,0,0,1-3-.08,1.4,1.4,0,0,0-.79.1,1,1,0,0,0-.41.64,6.48,6.48,0,0,0-.06.76,4.16,4.16,0,0,1-1.88,3.17c-.45.28-.94.47-1.4.74a4.72,4.72,0,0,0-1.36,1.42c-.5.65-1,1.33-1.5,2-1.77,2.18-2.56,2.3-6.25,3.21s-6.36-.37-11.6,0-24.11,3.43-32.63,3.67C63.85,207.32,63.07,202.45,62.48,191.51Z",
    style: {
      fill: "rgb(200, 133, 106)",
      transformOrigin: "102.989px 164.949px"
    },
    id: "el3epnm7451wu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.86,185.55c-6.39-1.19-13.23-.92-17.25,2,6.59-7.06,17.51-4.15,17.51-4.15Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "78.365px 185.178px"
    },
    id: "elk7y0qzsp0g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.77,121.07c-8.19,2.25-15.22,6.88-17,14.87S62,167.38,61.64,179.23s0,21.51,2.4,24.43,4.95,4.06,11.66,4.05,20.62-1.41,20.62-1.41S93.77,194,98.08,187.36l-9.92-2.18s3.52-29.58,4.32-36.61S93,129.05,82.77,121.07Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "79.8003px 164.39px"
    },
    id: "elcguqnx7aug9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Carpet--inject-114",
    className: "animable",
    style: {
      transformOrigin: "186.435px 171.425px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "222.25 135.63 170.1 147.74 149.63 205.91 150.62 207.22 200.31 194.73 223.24 136.95 222.25 135.63",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "186.435px 171.425px"
    },
    id: "elrhwizifu0vk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elyz1zoadzzil"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "171.09 149.06 150.62 207.22 149.63 205.91 170.1 147.74 171.09 149.06",
    style: {
      opacity: 0.35,
      transformOrigin: "160.36px 177.48px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elprfar3n9a4s"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "223.24 136.95 171.09 149.06 150.62 207.22 200.31 194.73 223.24 136.95",
    style: {
      opacity: 0.25,
      transformOrigin: "186.93px 172.085px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ellrmwmojabr7"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "194.945px 149.016px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.76,147.5s.28-.88.64-2-2.66-.83-6.73.56l-9.36,1.74c-4.06,1.39-7.86,2.34-8.21,3.42l-.64,2Z",
    id: "elozjg073qnt",
    className: "animable",
    style: {
      transformOrigin: "194.945px 149.016px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M210.75,138.77c.22-.67-.94-.66-2.59-.41l-3,.66s1.5-2.77-5.54-1.68c-7.75,1.2-8.33,4.94-8.33,4.94a35.06,35.06,0,0,1-3.77.91c-2.58.54-2.92,1-3.2,1.67l-.51,1.23,26.58-6.16S210.53,139.45,210.75,138.77Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "197.293px 141.588px"
    },
    id: "elvorb1c1unho",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.63,142.31c-2.48.81-3.53,1.23-4.07,2.89-.62,1.91-.8,2.71-.8,2.71l-13.9,3.77s1-2.79,1.32-3.72-1.47-1.15-3.9-.34l.82-2.32,21.56-5.4Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "197.47px 145.79px"
    },
    id: "els9v0cuw5k4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.44,147.61l.64-2c.35-1.08-2.66-.83-6.72.56L192,148c-4.07,1.39-7.87,2.34-8.22,3.42l-.64,1.95Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "195.624px 149.154px"
    },
    id: "el2t0y4b3n9dc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.91,163.7c1.78-2,1.67-2.26,1-3.45a6.79,6.79,0,0,0-5.15-3.45c-1.88-.16-3.78-.42-4.81,0s-.44,2.53,2,3.37c3.75,1.31,3.61,2.36,3.61,2.36A50.26,50.26,0,0,0,207.6,161c-1.42-.25-4.11.13-5.77.19s-2.23,2.13.45,3.18l-3,.13c-2.13.09-3,1.11-1.48,2.6a3.08,3.08,0,0,0,1.81.93s-2.23-.26-2.36.47c-.38,2.11.93,2.83,5.27,4.66,3.42,1.44,4.67,3.43,4.42,4.92l-.34.86s1.48-.93,3.14-1.81c1.22-.65,2.28-1.41,2-3.23,0,0,2.44.33,2.77-1.16a7.83,7.83,0,0,0-.21-3.32,2.68,2.68,0,0,0,1.64-2.35,4.33,4.33,0,0,0-.58-2.77Z",
    style: {
      fill: "rgb(200, 133, 106)",
      transformOrigin: "207.197px 167.756px"
    },
    id: "elzkbhpiioa3c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.28,164.4a14,14,0,0,1,2.74,0,9.13,9.13,0,0,1,2.53,1.14,32.84,32.84,0,0,1,4.43,3.09,31,31,0,0,1-4.83-2.4,14.58,14.58,0,0,0-2.28-1.23C204.08,164.8,203.14,164.67,202.28,164.4Z",
    style: {
      fill: "rgb(175, 97, 82)",
      transformOrigin: "207.13px 166.481px"
    },
    id: "el589ljw65z72",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.57,168.06a5.9,5.9,0,0,1,2.94.26,15.14,15.14,0,0,1,2.69,1.21,27.47,27.47,0,0,1,4.78,3.33c-1.8-.77-3.48-1.71-5.17-2.64A15.35,15.35,0,0,0,199.57,168.06Z",
    style: {
      fill: "rgb(175, 97, 82)",
      transformOrigin: "204.775px 170.42px"
    },
    id: "elupzvgw90kj8",
    className: "animable"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-114",
    className: "animable",
    style: {
      transformOrigin: "204.797px 75.0974px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-114",
    className: "animable",
    style: {
      transformOrigin: "204.797px 75.0974px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-114",
    className: "animable",
    style: {
      transformOrigin: "204.797px 75.0974px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.68,93l10.94,0a35.18,35.18,0,1,0-4.2-10.94l-8.1,7.34A2,2,0,0,0,167.68,93Zm29.61-48.14a32.24,32.24,0,0,1,22.36-.3L223.09,46a32.42,32.42,0,0,1-26.38,59.19l-3.35-1.59a32.41,32.41,0,0,1,3.93-58.73Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "204.797px 75.0974px"
    },
    id: "elektdghcsln",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.29,44.85a32.24,32.24,0,0,1,22.36-.3L223.09,46a32.42,32.42,0,0,1-26.38,59.19l-3.35-1.59a32.41,32.41,0,0,1,3.93-58.73Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "208.886px 75.1312px"
    },
    id: "el2qn1irqxqtv",
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "202.92 81.13 202.92 93.11 214.91 93.11 214.91 81.13 226.89 81.13 226.89 69.14 214.91 69.14 214.91 57.16 202.92 57.16 202.92 69.14 190.94 69.14 190.94 81.13 202.92 81.13",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "208.915px 75.135px"
    },
    id: "elkqjfmarvip",
    className: "animable"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedical);
export default __webpack_public_path__ + "static/media/medical.d27b25ef4ee9a35c18b137b6ae18a1c1.svg";
export { ForwardRef as ReactComponent };